export const getMonochromeStyle = (key: string, awsRegion: string) => {
  return {
    version: 8,
    name: 'AmazonLocation-Monochrome-Global-Light-Default',
    metadata: {
      version: '3.0.0',
    },
    sources: {
      aws: {
        attribution:
          '© <a href=\'https://docs.aws.amazon.com/location/latest/developerguide/data-attribution.html\'>AWS</a>, <a href=\'https://legal.here.com/en-gb/terms/general-content-supplier-terms-and-notices\'>HERE</a>',
        maxzoom: 17,
        minzoom: 0,
        tiles: [
          `https://maps.geo.${awsRegion}.amazonaws.com/v2/tiles/vector.basemap/{z}/{x}/{y}?key=${key}`,
        ],
        type: 'vector',
      },
    },
    sprite: `https://maps.geo.${awsRegion}.amazonaws.com/v2/styles/2_1_0/Monochrome/Light/Default/sprites/sprites`,
    glyphs: `https://maps.geo.${awsRegion}.amazonaws.com/v2/glyphs/{fontstack}/{range}.pbf`,
    layers: [
      {
        id: 'land',
        paint: {
          'background-color': [
            'interpolate',
            ['linear'],
            ['zoom'],
            15.5,
            'hsl(228, 0%, 87%)',
            16,
            'hsl(228, 0%, 85%)',
          ],
        },
        type: 'background',
      },
      {
        filter: [
          'all',
          ['match', ['get', 'kind'], ['transit', 'rail'], true, false],
          ['has', 'is_tunnel'],
          ['!', ['has', 'service']],
          [
            'case',
            [
              'all',
              ['has', 'kind_detail'],
              ['==', ['get', 'kind_detail'], 'disused'],
            ],
            false,
            true,
          ],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'rail_tunnel',
        layout: {
          'line-join': 'round',
        },
        minzoom: 12,
        paint: {
          'line-color': 'hsl(228, 0%, 91%)',
          'line-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            15,
            1,
            17,
            1.5,
            20,
            2,
          ],
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'line',
      },
      {
        filter: [
          'all',
          ['match', ['get', 'kind'], ['transit', 'rail'], true, false],
          ['has', 'is_tunnel'],
          ['!', ['has', 'service']],
          [
            'case',
            [
              'all',
              ['has', 'kind_detail'],
              ['==', ['get', 'kind_detail'], 'disused'],
            ],
            false,
            true,
          ],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'rail_tie_tunnel',
        minzoom: 14,
        paint: {
          'line-color': 'hsl(228, 0%, 91%)',
          'line-dasharray': [0.2, 2],
          'line-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            14,
            4,
            15,
            5,
            16,
            5,
            17,
            6,
            18,
            7,
            19,
            8,
            20,
            9,
          ],
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'line',
      },
      {
        filter: [
          'all',
          ['==', ['get', 'kind'], 'desert'],
          ['==', ['geometry-type'], 'Polygon'],
        ],
        id: 'landuse_desert',
        maxzoom: 12,
        minzoom: 0,
        paint: {
          'fill-color': [
            'interpolate',
            ['linear'],
            ['zoom'],
            8,
            'hsl(120, 1%, 84%)',
            12,
            'hsl(120, 1%, 84%)',
          ],
          'fill-opacity': ['interpolate', ['linear'], ['zoom'], 11.5, 1, 12, 0],
        },
        source: 'aws',
        'source-layer': 'landuse',
        type: 'fill',
      },
      {
        filter: [
          'all',
          ['==', ['get', 'kind'], 'glacier'],
          ['==', ['geometry-type'], 'Polygon'],
        ],
        id: 'landuse_glacier',
        paint: {
          'fill-color': 'hsl(120, 1%, 92%)',
        },
        source: 'aws',
        'source-layer': 'landuse',
        type: 'fill',
      },
      {
        filter: [
          'all',
          ['step', ['zoom'], ['>=', ['get', 'sort_rank'], 18], 9, true],
          [
            'match',
            ['get', 'kind'],
            [
              'allotments',
              'cemetery',
              'forest',
              'golf_course',
              'grass',
              'grassland',
              'meadow',
              'national_park',
              'natural_forest',
              'natural_wood',
              'nature_reserve',
              'park',
              'protected_area',
              'sports_centre',
              'theme_park',
              'water_park',
              'village_green',
              'wood',
              'zoo',
            ],
            true,
            false,
          ],
          ['==', ['geometry-type'], 'Polygon'],
        ],
        id: 'landuse_greenspace',
        paint: {
          'fill-color': 'hsl(120, 1%, 84%)',
          'fill-opacity': [
            'interpolate',
            ['linear'],
            ['zoom'],
            3.5,
            0.4,
            6,
            0.7,
          ],
        },
        source: 'aws',
        'source-layer': 'landuse',
        type: 'fill',
      },
      {
        filter: [
          'all',
          ['==', ['get', 'kind'], 'beach'],
          ['==', ['geometry-type'], 'Polygon'],
        ],
        id: 'landuse_beach',
        minzoom: 9,
        paint: {
          'fill-color': 'hsl(120, 1%, 84%)',
          'fill-opacity': ['interpolate', ['linear'], ['zoom'], 9, 0, 9.5, 1],
        },
        source: 'aws',
        'source-layer': 'landuse',
        type: 'fill',
      },
      {
        filter: [
          'all',
          ['match', ['get', 'kind'], ['region', 'macroregion'], true, false],
          ['match', ['to-number', ['get', 'kind_detail']], [3, 4], true, false],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'admin_region',
        layout: {
          'line-cap': 'round',
          'line-join': 'round',
        },
        minzoom: 2,
        paint: {
          'line-color': [
            'interpolate',
            ['linear'],
            ['zoom'],
            2,
            'hsl(228, 0%, 80%)',
            4,
            'hsl(228, 0%, 80%)',
            6,
            'hsl(228, 0%, 75%)',
          ],
          'line-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            2,
            1,
            6,
            1.5,
            15,
            3,
          ],
        },
        source: 'aws',
        'source-layer': 'boundaries',
        type: 'line',
      },
      {
        filter: [
          'all',
          ['!', ['has', 'is_tunnel']],
          ['!', ['has', 'intermittent']],
          ['==', ['geometry-type'], 'LineString'],
          ['step', ['zoom'], ['==', ['get', 'kind'], 'river'], 11, true],
        ],
        id: 'water_waterway',
        layout: {
          'line-cap': 'round',
          'line-join': 'round',
          'line-miter-limit': 0,
          'line-round-limit': 0,
        },
        minzoom: 9,
        paint: {
          'line-color': 'hsl(228, 6%, 76%)',
          'line-opacity': [
            'interpolate',
            ['linear'],
            ['zoom'],
            9,
            ['match', ['get', 'kind'], ['river'], 0.5, 0],
            12,
            ['match', ['get', 'kind'], ['river'], 1, 0],
            13,
            ['match', ['get', 'kind'], ['river'], 1, 0.5],
            14,
            1,
          ],
          'line-translate-anchor': 'viewport',
          'line-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            9,
            0.3,
            12,
            ['match', ['get', 'kind'], ['stream', 'drain', 'ditch'], 0.75, 1],
            14,
            ['match', ['get', 'kind'], ['stream', 'drain', 'ditch'], 1.5, 5],
            17,
            ['match', ['get', 'kind'], ['stream', 'drain', 'ditch'], 2, 40],
            20,
            ['match', ['get', 'kind'], ['stream', 'drain', 'ditch'], 10, 300],
          ],
        },
        source: 'aws',
        'source-layer': 'water',
        type: 'line',
      },
      {
        filter: [
          'all',
          ['>=', ['get', 'sort_rank'], 200],
          ['!', ['has', 'is_tunnel']],
          [
            'match',
            ['get', 'kind'],
            ['reef', 'playa', 'ocean', 'bathymetry'],
            false,
            true,
          ],
          ['!', ['has', 'intermittent']],
          ['==', ['geometry-type'], 'Polygon'],
        ],
        id: 'water_fill',
        paint: {
          'fill-antialias': false,
          'fill-color': 'hsl(228, 6%, 76%)',
          'fill-outline-color': 'hsl(228, 6%, 76%)',
          'fill-translate-anchor': 'viewport',
        },
        source: 'aws',
        'source-layer': 'water',
        type: 'fill',
      },
      {
        filter: [
          'all',
          ['==', ['get', 'kind'], 'country'],
          ['==', ['to-number', ['get', 'kind_detail']], 2],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'admin_country',
        layout: {
          'line-cap': 'round',
          'line-join': 'round',
        },
        minzoom: 1,
        paint: {
          'line-color': [
            'interpolate',
            ['linear'],
            ['zoom'],
            1,
            'hsl(228, 0%, 70%)',
            13,
            'hsl(228, 0%, 55%)',
          ],
          'line-width': [
            'interpolate',
            ['exponential', 1.3],
            ['zoom'],
            1,
            0.5,
            6,
            3,
            15,
            5,
          ],
        },
        source: 'aws',
        'source-layer': 'boundaries',
        type: 'line',
      },
      {
        filter: [
          'all',
          ['==', ['get', 'kind'], 'ocean'],
          ['==', ['geometry-type'], 'Polygon'],
        ],
        id: 'water_ocean',
        paint: {
          'fill-antialias': false,
          'fill-color': 'hsl(228, 6%, 76%)',
          'fill-outline-color': 'hsl(228, 6%, 76%)',
          'fill-translate-anchor': 'viewport',
        },
        source: 'aws',
        'source-layer': 'water',
        type: 'fill',
      },
      {
        filter: [
          'all',
          [
            'match',
            ['get', 'kind'],
            [
              'disputed',
              'disputed_claim',
              'disputed_reference_line',
              'line_of_control',
              'indefinite',
              'indeterminate',
              'lease_limit',
            ],
            true,
            false,
          ],
          ['!=', ['get', 'kind'], 'unrecognized_disputed'],
          ['match', ['to-number', ['get', 'kind_detail']], [3, 4], true, false],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'admin_region-disputed-mask',
        layout: {
          'line-cap': 'round',
          'line-join': 'round',
        },
        minzoom: 1,
        paint: {
          'line-color': [
            'interpolate',
            ['linear'],
            ['zoom'],
            14.5,
            'hsl(228, 0%, 87%)',
            15,
            'hsl(228, 0%, 85%)',
          ],
          'line-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            2,
            1,
            6,
            1.5,
            15,
            3,
          ],
        },
        source: 'aws',
        'source-layer': 'boundaries',
        type: 'line',
      },
      {
        filter: [
          'all',
          [
            'match',
            ['get', 'kind'],
            [
              'disputed',
              'disputed_claim',
              'disputed_reference_line',
              'line_of_control',
              'indefinite',
              'indeterminate',
              'lease_limit',
            ],
            true,
            false,
          ],
          ['!=', ['get', 'kind'], 'unrecognized_disputed'],
          ['match', ['to-number', ['get', 'kind_detail']], [3, 4], true, false],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'admin_region-disputed',
        layout: {
          'line-cap': 'round',
          'line-join': 'round',
        },
        minzoom: 2,
        paint: {
          'line-color': 'hsl(228, 0%, 100%)',
          'line-dasharray': [1, 2.5],
          'line-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            2,
            1.5,
            3,
            2,
            6,
            2,
            15,
            4.5,
            19,
            6,
          ],
        },
        source: 'aws',
        'source-layer': 'boundaries',
        type: 'line',
      },
      {
        filter: [
          'all',
          [
            'match',
            ['get', 'kind'],
            [
              'disputed',
              'disputed_claim',
              'disputed_reference_line',
              'line_of_control',
              'indefinite',
              'indeterminate',
              'lease_limit',
            ],
            true,
            false,
          ],
          ['!=', ['get', 'kind'], 'unrecognized_disputed'],
          ['==', ['to-number', ['get', 'kind_detail']], 2],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'admin_country-disputed-mask',
        layout: {
          'line-cap': 'round',
          'line-join': 'round',
        },
        minzoom: 1,
        paint: {
          'line-color': [
            'interpolate',
            ['linear'],
            ['zoom'],
            14.5,
            'hsl(228, 0%, 87%)',
            15,
            'hsl(228, 0%, 85%)',
          ],
          'line-width': [
            'interpolate',
            ['exponential', 1.3],
            ['zoom'],
            1,
            0.5,
            6,
            3,
            15,
            5,
          ],
        },
        source: 'aws',
        'source-layer': 'boundaries',
        type: 'line',
      },
      {
        filter: [
          'all',
          [
            'match',
            ['get', 'kind'],
            [
              'disputed',
              'disputed_claim',
              'disputed_reference_line',
              'line_of_control',
              'indefinite',
              'indeterminate',
              'lease_limit',
            ],
            true,
            false,
          ],
          ['!=', ['get', 'kind'], 'unrecognized_disputed'],
          ['==', ['to-number', ['get', 'kind_detail']], 2],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'admin_country-disputed',
        layout: {
          'line-cap': 'round',
          'line-join': 'round',
        },
        minzoom: 1,
        paint: {
          'line-color': [
            'interpolate',
            ['linear'],
            ['zoom'],
            8,
            'hsl(228, 0%, 70%)',
            13,
            'hsl(228, 0%, 55%)',
          ],
          'line-dasharray': [
            'step',
            ['zoom'],
            ['literal', [1, 4]],
            5,
            ['literal', [1.5, 2.5]],
            8,
            ['literal', [2.5, 3]],
          ],
          'line-width': [
            'interpolate',
            ['exponential', 1.3],
            ['zoom'],
            1,
            0.5,
            6,
            3,
            15,
            5,
          ],
        },
        source: 'aws',
        'source-layer': 'boundaries',
        type: 'line',
      },
      {
        filter: [
          'all',
          [
            'case',
            ['==', ['get', 'kind_detail'], 'pier'],
            true,
            ['==', ['get', 'kind_detail'], 'quay'],
            true,
            ['==', ['get', 'landuse_kind'], 'pier'],
            true,
            ['==', ['get', 'landuse_kind'], 'quay'],
            true,
            false,
          ],
          ['!=', ['get', 'kind'], 'rail'],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'water_pier-line',
        minzoom: 15,
        paint: {
          'line-color': 'hsl(228, 0%, 85%)',
          'line-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            15,
            2,
            17,
            7,
            20,
            50,
          ],
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'line',
      },
      {
        filter: [
          'all',
          ['match', ['get', 'kind'], ['bridge', 'pier', 'quay'], true, false],
          ['==', ['geometry-type'], 'Polygon'],
        ],
        id: 'water_pier-polygon',
        minzoom: 12,
        paint: {
          'fill-color': 'hsl(228, 0%, 85%)',
        },
        source: 'aws',
        'source-layer': 'landuse',
        type: 'fill',
      },
      {
        filter: [
          'all',
          ['==', ['get', 'kind'], 'building'],
          ['==', ['geometry-type'], 'Polygon'],
        ],
        id: 'building_fill',
        minzoom: 13,
        paint: {
          'fill-color': [
            'interpolate',
            ['linear'],
            ['zoom'],
            14,
            'hsl(228, 0%, 83%)',
            15,
            'hsl(228, 0%, 91%)',
          ],
          'fill-opacity': [
            'interpolate',
            ['linear'],
            ['zoom'],
            13,
            0,
            13.25,
            [
              'case',
              ['all', ['has', 'min_zoom'], ['<=', ['get', 'min_zoom'], 13]],
              1,
              0,
            ],
            14,
            [
              'case',
              ['all', ['has', 'min_zoom'], ['<=', ['get', 'min_zoom'], 13]],
              1,
              0,
            ],
            14.25,
            [
              'case',
              ['all', ['has', 'min_zoom'], ['<=', ['get', 'min_zoom'], 14]],
              1,
              0,
            ],
            15,
            [
              'case',
              ['all', ['has', 'min_zoom'], ['<=', ['get', 'min_zoom'], 14]],
              1,
              0,
            ],
            15.25,
            1,
          ],
        },
        source: 'aws',
        'source-layer': 'buildings',
        type: 'fill',
      },
      {
        filter: [
          'all',
          ['has', 'is_tunnel'],
          [
            'any',
            ['==', ['get', 'kind_detail'], 'service'],
            [
              'all',
              ['==', ['get', 'kind_detail'], 'residential'],
              ['==', ['get', 'private'], true],
            ],
          ],
          ['==', ['get', 'kind'], 'minor_road'],
          ['!', ['has', 'is_bridge']],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'tunnel_service-casing',
        layout: {
          'line-cap': 'round',
          'line-join': 'round',
        },
        minzoom: 15,
        paint: {
          'line-color': 'hsl(228, 0%, 83%)',
          'line-dasharray': [
            'step',
            ['zoom'],
            ['literal', [4, 2]],
            18,
            ['literal', [8, 4]],
          ],
          'line-gap-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            15,
            2,
            17,
            4,
            18,
            10,
            20,
            34,
          ],
          'line-opacity': ['interpolate', ['linear'], ['zoom'], 15, 0, 15.5, 1],
          'line-width': ['interpolate', ['linear'], ['zoom'], 15, 0.6, 18, 1.5],
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'line',
      },
      {
        filter: [
          'all',
          ['has', 'is_tunnel'],
          [
            'match',
            ['get', 'kind'],
            ['minor_road', 'unclassified', 'track'],
            true,
            false,
          ],
          ['!=', ['get', 'kind_detail'], 'service'],
          ['!=', ['get', 'private'], true],
          ['!', ['has', 'is_bridge']],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'tunnel_minor-casing',
        layout: {
          'line-cap': 'round',
          'line-join': 'round',
        },
        minzoom: 14.5,
        paint: {
          'line-color': 'hsl(228, 0%, 83%)',
          'line-dasharray': [
            'step',
            ['zoom'],
            ['literal', [10, 0]],
            15,
            ['literal', [4, 2]],
            18,
            ['literal', [8, 4]],
          ],
          'line-gap-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            13.5,
            1,
            15,
            3,
            17,
            8,
            18,
            15,
            20,
            80,
          ],
          'line-opacity': ['interpolate', ['linear'], ['zoom'], 14.5, 0, 15, 1],
          'line-width': ['interpolate', ['linear'], ['zoom'], 15, 0.6, 18, 1.5],
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'line',
      },
      {
        filter: [
          'all',
          ['has', 'is_tunnel'],
          ['==', ['get', 'kind_detail'], 'tertiary'],
          ['has', 'is_link'],
          ['!', ['has', 'is_bridge']],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'tunnel_tertiary-link-casing',
        layout: {
          'line-cap': 'round',
          'line-join': 'round',
        },
        minzoom: 14,
        paint: {
          'line-color': 'hsl(228, 0%, 83%)',
          'line-dasharray': [
            'step',
            ['zoom'],
            ['literal', [10, 0]],
            15,
            ['literal', [6, 4]],
            18,
            ['literal', [10, 5]],
            20,
            ['literal', [12, 8]],
          ],
          'line-gap-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            11,
            0.6,
            12,
            1,
            14,
            2,
            17,
            10,
            18,
            10,
            20,
            70,
          ],
          'line-opacity': ['interpolate', ['linear'], ['zoom'], 14, 0, 14.5, 1],
          'line-width': ['interpolate', ['linear'], ['zoom'], 15, 0.6, 17, 1.5],
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'line',
      },
      {
        filter: [
          'all',
          ['has', 'is_tunnel'],
          ['==', ['get', 'kind_detail'], 'secondary'],
          ['has', 'is_link'],
          ['!', ['has', 'is_bridge']],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'tunnel_primary-link-casing',
        layout: {
          'line-cap': 'round',
          'line-join': 'round',
        },
        minzoom: 14,
        paint: {
          'line-color': 'hsl(228, 0%, 80%)',
          'line-dasharray': [
            'step',
            ['zoom'],
            ['literal', [10, 0]],
            15,
            ['literal', [8, 4]],
            16,
            ['literal', [10, 5]],
            18,
            ['literal', [12, 8]],
          ],
          'line-gap-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            11,
            1,
            14,
            2.5,
            17,
            10,
            18,
            14,
            20,
            80,
          ],
          'line-opacity': ['interpolate', ['linear'], ['zoom'], 14, 0, 14.5, 1],
          'line-width': ['interpolate', ['linear'], ['zoom'], 15, 0.5, 17, 1.5],
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'line',
      },
      {
        filter: [
          'all',
          ['has', 'is_tunnel'],
          [
            'match',
            ['get', 'kind_detail'],
            ['motorway', 'trunk', 'primary'],
            true,
            false,
          ],
          ['has', 'is_link'],
          ['!', ['has', 'is_bridge']],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'tunnel_motorway-trunk-link-casing',
        layout: {
          'line-cap': 'round',
          'line-join': 'round',
        },
        minzoom: 13.5,
        paint: {
          'line-color': 'hsl(228, 0%, 80%)',
          'line-dasharray': [
            'step',
            ['zoom'],
            ['literal', [10, 0]],
            15,
            ['literal', [5, 3]],
            16,
            ['literal', [8, 4]],
            17,
            ['literal', [12, 5]],
            18,
            ['literal', [15, 8]],
            19,
            ['literal', [20, 10]],
            20,
            ['literal', [30, 15]],
          ],
          'line-gap-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            8,
            0.7,
            10,
            1,
            11,
            1.25,
            13,
            2,
            14,
            2.5,
            17,
            12,
            18,
            14,
            20,
            70,
          ],
          'line-opacity': ['interpolate', ['linear'], ['zoom'], 13.5, 0, 14, 1],
          'line-width': ['interpolate', ['linear'], ['zoom'], 13, 0.4, 17, 1.5],
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'line',
      },
      {
        filter: [
          'all',
          ['has', 'is_tunnel'],
          ['==', ['get', 'kind_detail'], 'tertiary'],
          ['!', ['has', 'is_bridge']],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'tunnel_tertiary-casing',
        layout: {
          'line-cap': 'round',
          'line-join': 'round',
        },
        minzoom: 14,
        paint: {
          'line-color': 'hsl(228, 0%, 83%)',
          'line-dasharray': [
            'step',
            ['zoom'],
            ['literal', [10, 0]],
            15,
            ['literal', [6, 4]],
            18,
            ['literal', [10, 5]],
            20,
            ['literal', [12, 8]],
          ],
          'line-gap-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            10,
            0.6,
            12,
            1,
            14,
            3,
            17,
            12,
            18,
            22,
            20,
            100,
          ],
          'line-opacity': ['interpolate', ['linear'], ['zoom'], 14, 0, 14.5, 1],
          'line-width': ['interpolate', ['linear'], ['zoom'], 15, 0.6, 18, 1.5],
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'line',
      },
      {
        filter: [
          'all',
          ['has', 'is_tunnel'],
          ['==', ['get', 'kind_detail'], 'secondary'],
          ['!', ['has', 'is_bridge']],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'tunnel_primary-casing',
        layout: {
          'line-cap': 'round',
          'line-join': 'round',
        },
        minzoom: 14,
        paint: {
          'line-color': 'hsl(228, 0%, 80%)',
          'line-dasharray': [
            'step',
            ['zoom'],
            ['literal', [10, 0]],
            15,
            ['literal', [8, 4]],
            16,
            ['literal', [10, 5]],
            18,
            ['literal', [12, 8]],
          ],
          'line-gap-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            9,
            0.8,
            11,
            1.25,
            12,
            2,
            14,
            4,
            17,
            16,
            18,
            30,
            20,
            100,
          ],
          'line-opacity': ['interpolate', ['linear'], ['zoom'], 14, 0, 14.5, 1],
          'line-width': ['interpolate', ['linear'], ['zoom'], 14, 0.6, 18, 1.5],
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'line',
      },
      {
        filter: [
          'all',
          ['has', 'is_tunnel'],
          [
            'match',
            ['get', 'kind_detail'],
            ['motorway', 'trunk', 'primary'],
            true,
            false,
          ],
          ['!', ['has', 'is_bridge']],
          ['!', ['has', 'is_link']],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'tunnel_motorway-trunk-casing',
        layout: {
          'line-cap': 'round',
          'line-join': 'round',
        },
        minzoom: 8,
        paint: {
          'line-color': 'hsl(228, 0%, 80%)',
          'line-dasharray': [
            'step',
            ['zoom'],
            ['literal', [10, 0]],
            15,
            ['literal', [5, 3]],
            16,
            ['literal', [8, 4]],
            17,
            ['literal', [12, 5]],
            18,
            ['literal', [15, 8]],
            19,
            ['literal', [20, 10]],
            20,
            ['literal', [30, 15]],
          ],
          'line-gap-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            7,
            0.7,
            9,
            0.8,
            11,
            2,
            12,
            3,
            14,
            5,
            17,
            20,
            18,
            50,
            20,
            200,
          ],
          'line-width': ['interpolate', ['linear'], ['zoom'], 12, 0.6, 15, 2],
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'line',
      },
      {
        filter: [
          'all',
          ['==', ['get', 'kind'], 'minor_road'],
          [
            'any',
            ['==', ['get', 'kind_detail'], 'service'],
            [
              'all',
              ['==', ['get', 'kind_detail'], 'residential'],
              ['==', ['get', 'private'], true],
            ],
          ],
          ['!', ['has', 'is_link']],
          [
            'all',
            ['!', ['has', 'is_bridge']],
            ['any', ['!', ['has', 'z_level']], ['==', ['get', 'z_level'], 0]],
          ],
          ['!', ['has', 'is_tunnel']],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'road_service-casing',
        layout: {
          'line-cap': 'round',
          'line-join': 'round',
        },
        minzoom: 15,
        paint: {
          'line-color': 'hsl(228, 0%, 83%)',
          'line-gap-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            15,
            2,
            17,
            4,
            18,
            10,
            20,
            34,
          ],
          'line-opacity': ['interpolate', ['linear'], ['zoom'], 15, 0, 15.5, 1],
          'line-width': ['interpolate', ['linear'], ['zoom'], 15, 0.8, 18, 1.5],
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'line',
      },
      {
        filter: [
          'all',
          [
            'match',
            ['get', 'kind'],
            ['minor_road', 'unclassified', 'track'],
            true,
            false,
          ],
          ['!=', ['get', 'kind_detail'], 'service'],
          ['!=', ['get', 'private'], true],
          [
            'all',
            ['!', ['has', 'is_bridge']],
            ['any', ['!', ['has', 'z_level']], ['==', ['get', 'z_level'], 0]],
          ],
          ['!', ['has', 'is_tunnel']],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'road_minor-casing',
        layout: {
          'line-cap': 'round',
          'line-join': 'round',
        },
        minzoom: 14.5,
        paint: {
          'line-color': 'hsl(228, 0%, 83%)',
          'line-gap-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            13.5,
            1,
            15,
            3,
            17,
            8,
            18,
            15,
            20,
            80,
          ],
          'line-opacity': ['interpolate', ['linear'], ['zoom'], 14.5, 0, 15, 1],
          'line-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            14.5,
            0.8,
            18,
            1.5,
          ],
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'line',
      },
      {
        filter: [
          'all',
          ['==', ['get', 'kind_detail'], 'tertiary'],
          ['has', 'is_link'],
          [
            'all',
            ['!', ['has', 'is_bridge']],
            ['any', ['!', ['has', 'z_level']], ['==', ['get', 'z_level'], 0]],
          ],
          ['!', ['has', 'is_tunnel']],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'road_tertiary-link-casing',
        layout: {
          'line-cap': 'round',
          'line-join': 'round',
        },
        minzoom: 14.5,
        paint: {
          'line-color': 'hsl(228, 0%, 83%)',
          'line-gap-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            11,
            0.6,
            12,
            1,
            14,
            2,
            17,
            10,
            18,
            10,
            20,
            70,
          ],
          'line-opacity': ['interpolate', ['linear'], ['zoom'], 14.5, 0, 15, 1],
          'line-width': ['interpolate', ['linear'], ['zoom'], 15, 0.6, 17, 1.5],
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'line',
      },
      {
        filter: [
          'all',
          ['==', ['get', 'kind_detail'], 'secondary'],
          ['has', 'is_link'],
          [
            'all',
            ['!', ['has', 'is_bridge']],
            ['any', ['!', ['has', 'z_level']], ['==', ['get', 'z_level'], 0]],
          ],
          ['!', ['has', 'is_tunnel']],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'road_primary-link-casing',
        layout: {
          'line-cap': 'round',
          'line-join': 'round',
        },
        minzoom: 12,
        paint: {
          'line-color': [
            'interpolate',
            ['linear'],
            ['zoom'],
            14.5,
            'hsl(228, 0%, 87%)',
            14.75,
            'hsl(228, 0%, 83%)',
          ],
          'line-gap-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            11,
            1,
            14,
            2.5,
            17,
            10,
            18,
            14,
            20,
            80,
          ],
          'line-opacity': ['interpolate', ['linear'], ['zoom'], 12, 0, 12.5, 1],
          'line-width': ['interpolate', ['linear'], ['zoom'], 15, 0.5, 17, 1.5],
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'line',
      },
      {
        filter: [
          'all',
          [
            'match',
            ['get', 'kind_detail'],
            ['motorway', 'trunk', 'primary'],
            true,
            false,
          ],
          ['has', 'is_link'],
          [
            'all',
            ['!', ['has', 'is_bridge']],
            ['any', ['!', ['has', 'z_level']], ['==', ['get', 'z_level'], 0]],
          ],
          ['!', ['has', 'is_tunnel']],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'road_motorway-trunk-link-casing',
        layout: {
          'line-cap': 'round',
          'line-join': 'round',
        },
        minzoom: 13.5,
        paint: {
          'line-color': 'hsl(228, 0%, 80%)',
          'line-gap-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            8,
            0.7,
            10,
            1,
            11,
            1.25,
            13,
            2,
            14,
            2.5,
            17,
            12,
            18,
            14,
            20,
            70,
          ],
          'line-opacity': ['interpolate', ['linear'], ['zoom'], 13.5, 0, 14, 1],
          'line-width': ['interpolate', ['linear'], ['zoom'], 13, 0.4, 17, 1.5],
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'line',
      },
      {
        filter: [
          'all',
          ['==', ['get', 'kind_detail'], 'tertiary'],
          ['!', ['has', 'is_link']],
          [
            'all',
            ['!', ['has', 'is_bridge']],
            ['any', ['!', ['has', 'z_level']], ['==', ['get', 'z_level'], 0]],
          ],
          ['!', ['has', 'is_tunnel']],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'road_tertiary-casing',
        layout: {
          'line-cap': 'round',
          'line-join': 'round',
        },
        minzoom: 14.5,
        paint: {
          'line-color': 'hsl(228, 0%, 83%)',
          'line-gap-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            10,
            0.6,
            12,
            1,
            14,
            3,
            17,
            12,
            18,
            22,
            20,
            100,
          ],
          'line-opacity': ['interpolate', ['linear'], ['zoom'], 14.5, 0, 15, 1],
          'line-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            14,
            1.125,
            15,
            1.5,
          ],
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'line',
      },
      {
        filter: [
          'all',
          ['==', ['get', 'kind_detail'], 'secondary'],
          ['!', ['has', 'is_link']],
          [
            'all',
            ['!', ['has', 'is_bridge']],
            ['any', ['!', ['has', 'z_level']], ['==', ['get', 'z_level'], 0]],
          ],
          ['!', ['has', 'is_tunnel']],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'road_primary-casing',
        layout: {
          'line-cap': 'round',
          'line-join': 'round',
        },
        minzoom: 12,
        paint: {
          'line-color': [
            'interpolate',
            ['linear'],
            ['zoom'],
            14.5,
            'hsl(228, 0%, 87%)',
            14.75,
            'hsl(228, 0%, 83%)',
          ],
          'line-gap-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            9,
            0.8,
            11,
            1.25,
            12,
            2,
            14,
            4,
            17,
            16,
            18,
            30,
            20,
            100,
          ],
          'line-opacity': ['interpolate', ['linear'], ['zoom'], 12, 0, 12.5, 1],
          'line-width': ['interpolate', ['linear'], ['zoom'], 13, 1, 15, 1.5],
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'line',
      },
      {
        filter: [
          'all',
          [
            'match',
            ['get', 'kind_detail'],
            ['motorway', 'trunk', 'primary'],
            true,
            false,
          ],
          ['!', ['has', 'is_link']],
          [
            'all',
            ['!', ['has', 'is_bridge']],
            ['any', ['!', ['has', 'z_level']], ['==', ['get', 'z_level'], 0]],
          ],
          ['!', ['has', 'is_tunnel']],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'road_motorway-trunk-casing',
        layout: {
          'line-cap': 'round',
          'line-join': 'round',
        },
        minzoom: 8,
        paint: {
          'line-color': 'hsl(228, 0%, 80%)',
          'line-gap-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            7,
            0.7,
            9,
            0.8,
            11,
            2,
            12,
            3,
            14,
            5,
            17,
            20,
            18,
            50,
            20,
            200,
          ],
          'line-opacity': ['interpolate', ['linear'], ['zoom'], 8, 0, 8.5, 1],
          'line-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            8,
            0.5,
            13,
            0.6,
            15,
            1.5,
          ],
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'line',
      },
      {
        filter: [
          'all',
          ['has', 'is_tunnel'],
          [
            'any',
            ['==', ['get', 'kind_detail'], 'service'],
            [
              'all',
              ['==', ['get', 'kind_detail'], 'residential'],
              ['==', ['get', 'private'], true],
            ],
          ],
          ['==', ['get', 'kind'], 'minor_road'],
          ['!', ['has', 'is_bridge']],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'tunnel_service',
        layout: {
          'line-cap': 'round',
          'line-join': 'round',
        },
        minzoom: 15,
        paint: {
          'line-color': 'hsl(228, 0%, 98%)',
          'line-opacity': ['interpolate', ['linear'], ['zoom'], 15, 0, 15.5, 1],
          'line-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            15,
            2,
            17,
            4,
            18,
            10,
            20,
            34,
          ],
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'line',
      },
      {
        filter: [
          'all',
          ['has', 'is_tunnel'],
          [
            'match',
            ['get', 'kind'],
            ['minor_road', 'unclassified', 'track'],
            true,
            false,
          ],
          ['!=', ['get', 'kind_detail'], 'service'],
          ['!=', ['get', 'private'], true],
          ['!', ['has', 'is_bridge']],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'tunnel_minor',
        layout: {
          'line-cap': 'round',
          'line-join': 'round',
        },
        minzoom: 12,
        paint: {
          'line-color': 'hsl(228, 0%, 98%)',
          'line-opacity': ['interpolate', ['linear'], ['zoom'], 12.5, 0, 13, 1],
          'line-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            13.5,
            1,
            15,
            3,
            17,
            8,
            18,
            15,
            20,
            80,
          ],
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'line',
      },
      {
        filter: [
          'all',
          ['has', 'is_tunnel'],
          ['==', ['get', 'kind_detail'], 'tertiary'],
          ['has', 'is_link'],
          ['!', ['has', 'is_bridge']],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'tunnel_tertiary-link',
        layout: {
          'line-cap': 'round',
          'line-join': 'round',
        },
        minzoom: 11,
        paint: {
          'line-color': 'hsl(228, 0%, 98%)',
          'line-opacity': ['interpolate', ['linear'], ['zoom'], 11.5, 0, 12, 1],
          'line-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            11,
            0.6,
            12,
            1,
            14,
            2,
            17,
            10,
            18,
            10,
            20,
            70,
          ],
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'line',
      },
      {
        filter: [
          'all',
          ['has', 'is_tunnel'],
          ['==', ['get', 'kind_detail'], 'secondary'],
          ['has', 'is_link'],
          ['!', ['has', 'is_bridge']],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'tunnel_primary-link',
        layout: {
          'line-cap': 'round',
          'line-join': 'round',
        },
        minzoom: 11,
        paint: {
          'line-color': 'hsl(228, 0%, 98%)',
          'line-opacity': ['interpolate', ['linear'], ['zoom'], 11, 0, 11.5, 1],
          'line-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            11,
            1,
            14,
            2.5,
            17,
            10,
            18,
            14,
            20,
            80,
          ],
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'line',
      },
      {
        filter: [
          'all',
          ['has', 'is_tunnel'],
          [
            'match',
            ['get', 'kind_detail'],
            ['motorway', 'trunk', 'primary'],
            true,
            false,
          ],
          ['has', 'is_link'],
          ['!', ['has', 'is_bridge']],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'tunnel_motorway-trunk-link',
        layout: {
          'line-cap': 'round',
          'line-join': 'round',
        },
        minzoom: 8,
        paint: {
          'line-color': [
            'interpolate',
            ['linear'],
            ['zoom'],
            13.25,
            'hsl(228, 0%, 97%)',
            13.5,
            'hsl(228, 0%, 96%)',
          ],
          'line-opacity': ['interpolate', ['linear'], ['zoom'], 8, 0, 8.5, 1],
          'line-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            8,
            0.7,
            10,
            1,
            11,
            1.25,
            13,
            2,
            14,
            2.5,
            17,
            12,
            18,
            14,
            20,
            70,
          ],
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'line',
      },
      {
        filter: [
          'all',
          ['has', 'is_tunnel'],
          ['==', ['get', 'kind_detail'], 'tertiary'],
          ['!', ['has', 'is_bridge']],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'tunnel_tertiary',
        layout: {
          'line-cap': 'round',
          'line-join': 'round',
        },
        minzoom: 12,
        paint: {
          'line-color': 'hsl(228, 0%, 98%)',
          'line-opacity': ['interpolate', ['linear'], ['zoom'], 12, 0, 12.5, 1],
          'line-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            10,
            0.6,
            12,
            1,
            14,
            3,
            17,
            12,
            18,
            22,
            20,
            100,
          ],
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'line',
      },
      {
        filter: [
          'all',
          ['has', 'is_tunnel'],
          ['==', ['get', 'kind_detail'], 'secondary'],
          ['!', ['has', 'is_bridge']],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'tunnel_primary',
        layout: {
          'line-cap': 'round',
          'line-join': 'round',
        },
        minzoom: 9,
        paint: {
          'line-color': 'hsl(228, 0%, 98%)',
          'line-opacity': ['interpolate', ['linear'], ['zoom'], 9, 0, 9.5, 1],
          'line-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            9,
            0.8,
            11,
            1.25,
            12,
            2,
            14,
            4,
            17,
            16,
            18,
            30,
            20,
            100,
          ],
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'line',
      },
      {
        filter: [
          'all',
          ['has', 'is_tunnel'],
          [
            'match',
            ['get', 'kind_detail'],
            ['motorway', 'trunk', 'primary'],
            true,
            false,
          ],
          ['!', ['has', 'is_bridge']],
          ['!', ['has', 'is_link']],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'tunnel_motorway-trunk',
        layout: {
          'line-cap': 'round',
          'line-join': 'round',
        },
        minzoom: 12,
        paint: {
          'line-color': 'hsl(228, 0%, 96%)',
          'line-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            7,
            0.7,
            9,
            0.8,
            11,
            2,
            12,
            3,
            14,
            5,
            17,
            20,
            18,
            50,
            20,
            200,
          ],
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'line',
      },
      {
        filter: [
          'all',
          ['==', ['get', 'kind'], 'runway'],
          ['==', ['geometry-type'], 'Polygon'],
        ],
        id: 'landuse_runway',
        minzoom: 11,
        paint: {
          'fill-color': [
            'interpolate',
            ['linear'],
            ['zoom'],
            14.5,
            'hsl(228, 0%, 93%)',
            15,
            'hsl(228, 0%, 95%)',
          ],
          'fill-opacity': ['interpolate', ['linear'], ['zoom'], 11, 0, 11.5, 1],
        },
        source: 'aws',
        'source-layer': 'landuse',
        type: 'fill',
      },
      {
        filter: [
          'all',
          ['match', ['get', 'kind_detail'], ['runway', 'taxiway'], true, false],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'airport_runway-casing',
        layout: {
          'line-join': 'round',
        },
        minzoom: 14,
        paint: {
          'line-color': 'hsl(228, 0%, 91%)',
          'line-gap-width': [
            'interpolate',
            ['exponential', 1.9],
            ['zoom'],
            12,
            ['match', ['get', 'kind_detail'], 'runway', 5, 0],
            20,
            ['match', ['get', 'kind_detail'], 'runway', 800, 200],
          ],
          'line-opacity': ['interpolate', ['linear'], ['zoom'], 14, 0, 14.5, 1],
          'line-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            14.5,
            0.8,
            18,
            1.5,
          ],
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'line',
      },
      {
        filter: [
          'all',
          ['match', ['get', 'kind_detail'], ['runway', 'taxiway'], true, false],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'airport_runway',
        layout: {
          'line-join': 'round',
        },
        minzoom: 11,
        paint: {
          'line-color': [
            'interpolate',
            ['linear'],
            ['zoom'],
            14.5,
            'hsl(228, 0%, 93%)',
            15,
            'hsl(228, 0%, 95%)',
          ],
          'line-opacity': ['interpolate', ['linear'], ['zoom'], 11, 0, 11.5, 1],
          'line-width': [
            'interpolate',
            ['exponential', 1.9],
            ['zoom'],
            12,
            ['match', ['get', 'kind_detail'], 'runway', 5, 0],
            20,
            ['match', ['get', 'kind_detail'], 'runway', 800, 200],
          ],
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'line',
      },
      {
        filter: [
          'all',
          ['==', ['get', 'kind'], 'building'],
          ['==', ['geometry-type'], 'Polygon'],
        ],
        id: 'building_line',
        minzoom: 15,
        paint: {
          'line-blur': ['interpolate', ['linear'], ['zoom'], 15, 1, 17, 0],
          'line-color': 'hsl(228, 0%, 70%)',
          'line-opacity': ['interpolate', ['linear'], ['zoom'], 15, 0, 16, 0.8],
          'line-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            15,
            0.65,
            17,
            0.5,
          ],
        },
        source: 'aws',
        'source-layer': 'buildings',
        type: 'line',
      },
      {
        filter: [
          'all',
          ['==', ['get', 'kind'], 'minor_road'],
          [
            'any',
            ['==', ['get', 'kind_detail'], 'service'],
            [
              'all',
              ['==', ['get', 'kind_detail'], 'residential'],
              ['==', ['get', 'private'], true],
            ],
          ],
          ['!', ['has', 'is_link']],
          [
            'all',
            ['!', ['has', 'is_bridge']],
            ['any', ['!', ['has', 'z_level']], ['==', ['get', 'z_level'], 0]],
          ],
          ['!', ['has', 'is_tunnel']],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'road_service',
        layout: {
          'line-cap': 'round',
          'line-join': 'round',
        },
        minzoom: 15,
        paint: {
          'line-color': [
            'interpolate',
            ['linear'],
            ['zoom'],
            17,
            'hsl(228, 0%, 96%)',
            18,
            'hsl(228, 0%, 98%)',
          ],
          'line-opacity': ['interpolate', ['linear'], ['zoom'], 15, 0, 15.5, 1],
          'line-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            15,
            2,
            17,
            4,
            18,
            10,
            20,
            34,
          ],
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'line',
      },
      {
        filter: [
          'all',
          [
            'match',
            ['get', 'kind'],
            ['minor_road', 'unclassified', 'track'],
            true,
            false,
          ],
          ['!=', ['get', 'kind_detail'], 'service'],
          ['!=', ['get', 'private'], true],
          [
            'all',
            ['!', ['has', 'is_bridge']],
            ['any', ['!', ['has', 'z_level']], ['==', ['get', 'z_level'], 0]],
          ],
          ['!', ['has', 'is_tunnel']],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'road_minor',
        layout: {
          'line-cap': 'round',
          'line-join': 'round',
        },
        minzoom: 12,
        paint: {
          'line-color': [
            'interpolate',
            ['linear'],
            ['zoom'],
            16,
            'hsl(228, 0%, 96%)',
            17,
            'hsl(228, 0%, 98%)',
          ],
          'line-opacity': ['interpolate', ['linear'], ['zoom'], 12.5, 0, 13, 1],
          'line-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            13.5,
            1,
            15,
            3,
            17,
            8,
            18,
            15,
            20,
            80,
          ],
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'line',
      },
      {
        filter: [
          'all',
          ['==', ['get', 'kind_detail'], 'tertiary'],
          ['has', 'is_link'],
          [
            'all',
            ['!', ['has', 'is_bridge']],
            ['any', ['!', ['has', 'z_level']], ['==', ['get', 'z_level'], 0]],
          ],
          ['!', ['has', 'is_tunnel']],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'road_tertiary-link',
        layout: {
          'line-cap': 'round',
          'line-join': 'round',
        },
        minzoom: 11,
        paint: {
          'line-color': [
            'interpolate',
            ['linear'],
            ['zoom'],
            15,
            'hsl(228, 0%, 96%)',
            16,
            'hsl(228, 0%, 98%)',
          ],
          'line-opacity': ['interpolate', ['linear'], ['zoom'], 11.5, 0, 12, 1],
          'line-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            11,
            0.6,
            12,
            1,
            14,
            2,
            17,
            10,
            18,
            10,
            20,
            70,
          ],
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'line',
      },
      {
        filter: [
          'all',
          ['==', ['get', 'kind_detail'], 'secondary'],
          ['has', 'is_link'],
          [
            'all',
            ['!', ['has', 'is_bridge']],
            ['any', ['!', ['has', 'z_level']], ['==', ['get', 'z_level'], 0]],
          ],
          ['!', ['has', 'is_tunnel']],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'road_primary-link',
        layout: {
          'line-cap': 'round',
          'line-join': 'round',
        },
        minzoom: 11,
        paint: {
          'line-color': [
            'interpolate',
            ['linear'],
            ['zoom'],
            12,
            'hsl(228, 0%, 96%)',
            14.5,
            'hsl(228, 0%, 97%)',
            15,
            'hsl(228, 0%, 98%)',
          ],
          'line-opacity': ['interpolate', ['linear'], ['zoom'], 11, 0, 11.5, 1],
          'line-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            11,
            1,
            14,
            2.5,
            17,
            10,
            18,
            14,
            20,
            80,
          ],
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'line',
      },
      {
        filter: [
          'all',
          [
            'match',
            ['get', 'kind_detail'],
            ['motorway', 'trunk', 'primary'],
            true,
            false,
          ],
          ['has', 'is_link'],
          [
            'all',
            ['!', ['has', 'is_bridge']],
            ['any', ['!', ['has', 'z_level']], ['==', ['get', 'z_level'], 0]],
          ],
          ['!', ['has', 'is_tunnel']],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'road_motorway-trunk-link',
        layout: {
          'line-cap': 'round',
          'line-join': 'round',
        },
        minzoom: 8,
        paint: {
          'line-color': [
            'interpolate',
            ['linear'],
            ['zoom'],
            13.25,
            'hsl(228, 0%, 97%)',
            13.5,
            'hsl(228, 0%, 97%)',
            15,
            'hsl(228, 0%, 97%)',
            16,
            'hsl(228, 0%, 98%)',
          ],
          'line-opacity': ['interpolate', ['linear'], ['zoom'], 8, 0, 8.5, 1],
          'line-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            8,
            0.7,
            10,
            1,
            11,
            1.25,
            13,
            2,
            14,
            2.5,
            17,
            12,
            18,
            14,
            20,
            70,
          ],
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'line',
      },
      {
        filter: [
          'all',
          ['==', ['get', 'kind_detail'], 'tertiary'],
          ['!', ['has', 'is_link']],
          [
            'all',
            ['!', ['has', 'is_bridge']],
            ['any', ['!', ['has', 'z_level']], ['==', ['get', 'z_level'], 0]],
          ],
          ['!', ['has', 'is_tunnel']],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'road_tertiary',
        layout: {
          'line-cap': 'round',
          'line-join': 'round',
        },
        minzoom: 10,
        paint: {
          'line-color': [
            'interpolate',
            ['linear'],
            ['zoom'],
            15,
            'hsl(228, 0%, 96%)',
            16,
            'hsl(228, 0%, 98%)',
          ],
          'line-opacity': ['interpolate', ['linear'], ['zoom'], 10, 0, 10.5, 1],
          'line-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            10,
            0.6,
            12,
            1,
            14,
            3,
            17,
            12,
            18,
            22,
            20,
            100,
          ],
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'line',
      },
      {
        filter: [
          'all',
          ['==', ['get', 'kind_detail'], 'secondary'],
          [
            'all',
            ['!', ['has', 'is_bridge']],
            ['any', ['!', ['has', 'z_level']], ['==', ['get', 'z_level'], 0]],
          ],
          ['!', ['has', 'is_tunnel']],
          ['!', ['has', 'is_link']],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'road_primary',
        layout: {
          'line-cap': 'round',
          'line-join': 'round',
        },
        minzoom: 8,
        paint: {
          'line-color': [
            'interpolate',
            ['linear'],
            ['zoom'],
            12,
            'hsl(228, 0%, 96%)',
            14.5,
            'hsl(228, 0%, 97%)',
            15,
            'hsl(228, 0%, 98%)',
          ],
          'line-opacity': ['interpolate', ['linear'], ['zoom'], 8.5, 0, 9, 1],
          'line-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            9,
            0.8,
            11,
            1.25,
            12,
            2,
            14,
            4,
            17,
            16,
            18,
            30,
            20,
            100,
          ],
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'line',
      },
      {
        filter: [
          'all',
          [
            'match',
            ['get', 'kind_detail'],
            ['motorway', 'trunk', 'primary'],
            true,
            false,
          ],
          [
            'step',
            ['zoom'],
            [
              'any',
              [
                'all',
                ['!', ['has', 'is_bridge']],
                [
                  'any',
                  ['!', ['has', 'z_level']],
                  ['==', ['get', 'z_level'], 0],
                ],
              ],
              ['!', ['has', 'is_tunnel']],
              ['has', 'is_bridge'],
              ['has', 'is_tunnel'],
            ],
            12,
            ['all', ['!', ['has', 'is_bridge']], ['!', ['has', 'is_tunnel']]],
          ],
          ['!', ['has', 'is_link']],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'road_motorway-trunk',
        layout: {
          'line-cap': 'round',
          'line-join': 'round',
        },
        minzoom: 5.75,
        paint: {
          'line-color': [
            'interpolate',
            ['linear'],
            ['zoom'],
            15,
            'hsl(228, 0%, 97%)',
            16,
            'hsl(228, 0%, 98%)',
          ],
          'line-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            7,
            0.7,
            9,
            0.8,
            11,
            2,
            12,
            3,
            14,
            5,
            17,
            20,
            18,
            50,
            20,
            200,
          ],
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'line',
      },
      {
        filter: [
          'all',
          ['match', ['get', 'kind'], ['transit', 'rail'], true, false],
          ['step', ['zoom'], ['!', ['has', 'service']], 14, true],
          ['!', ['has', 'is_bridge']],
          ['!', ['has', 'is_tunnel']],
          [
            'case',
            [
              'all',
              ['has', 'kind_detail'],
              ['==', ['get', 'kind_detail'], 'disused'],
            ],
            false,
            true,
          ],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'rail_road',
        layout: {
          'line-join': 'round',
        },
        minzoom: 11,
        paint: {
          'line-color': [
            'interpolate',
            ['linear'],
            ['zoom'],
            16,
            'hsl(228, 0%, 74%)',
            17,
            'hsl(228, 0%, 70%)',
          ],
          'line-opacity': [
            'interpolate',
            ['linear'],
            ['zoom'],
            11.5,
            0,
            12,
            ['case', ['has', 'service'], 0, 1],
            14,
            ['case', ['has', 'service'], 0, 1],
            15,
            1,
          ],
          'line-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            15,
            1,
            17,
            1.5,
            20,
            2,
          ],
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'line',
      },
      {
        filter: [
          'all',
          ['match', ['get', 'kind'], ['transit', 'rail'], true, false],
          ['!', ['has', 'is_bridge']],
          ['!', ['has', 'is_tunnel']],
          [
            'case',
            [
              'all',
              ['has', 'kind_detail'],
              ['==', ['get', 'kind_detail'], 'disused'],
            ],
            false,
            true,
          ],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'rail_tie',
        minzoom: 14,
        paint: {
          'line-color': [
            'interpolate',
            ['linear'],
            ['zoom'],
            16,
            'hsl(228, 0%, 74%)',
            17,
            'hsl(228, 0%, 70%)',
          ],
          'line-dasharray': [0.2, 2],
          'line-opacity': [
            'interpolate',
            ['linear'],
            ['zoom'],
            14,
            ['case', ['has', 'service'], 0, 1],
            15,
            1,
          ],
          'line-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            14,
            4,
            15,
            5,
            16,
            5,
            17,
            6,
            18,
            7,
            19,
            8,
            20,
            9,
          ],
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'line',
      },
      {
        filter: [
          'all',
          ['any', ['has', 'is_bridge'], ['>', ['get', 'z_level'], 0]],
          [
            'any',
            ['==', ['get', 'kind_detail'], 'service'],
            [
              'all',
              ['==', ['get', 'kind_detail'], 'residential'],
              ['==', ['get', 'private'], true],
            ],
          ],
          ['==', ['get', 'kind'], 'minor_road'],
          ['!', ['has', 'is_tunnel']],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'bridge_service-shadow',
        layout: {
          'line-join': 'round',
        },
        minzoom: 15,
        paint: {
          'line-blur': [
            'interpolate',
            ['linear'],
            ['zoom'],
            15,
            4,
            17,
            9,
            18,
            15,
            20,
            25,
          ],
          'line-color': 'hsl(228, 0%, 0%)',
          'line-opacity': [
            'interpolate',
            ['linear'],
            ['zoom'],
            15,
            0,
            15.5,
            0.3,
          ],
          'line-translate': [
            'interpolate',
            ['linear'],
            ['zoom'],
            15,
            ['literal', [2, 2]],
            17,
            ['literal', [2.5, 2.5]],
            18,
            ['literal', [3, 3]],
            20,
            ['literal', [7, 7]],
          ],
          'line-translate-anchor': 'viewport',
          'line-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            15,
            2,
            17,
            5,
            18,
            15,
            20,
            40,
          ],
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'line',
      },
      {
        filter: [
          'all',
          ['any', ['has', 'is_bridge'], ['>', ['get', 'z_level'], 0]],
          [
            'match',
            ['get', 'kind'],
            ['minor_road', 'unclassified', 'track'],
            true,
            false,
          ],
          ['!=', ['get', 'kind_detail'], 'service'],
          ['!=', ['get', 'private'], true],
          ['!', ['has', 'is_tunnel']],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'bridge_minor-shadow',
        layout: {
          'line-join': 'round',
        },
        minzoom: 15,
        paint: {
          'line-blur': [
            'interpolate',
            ['linear'],
            ['zoom'],
            15,
            7,
            17,
            12,
            18,
            20,
            20,
            25,
          ],
          'line-color': 'hsl(228, 0%, 0%)',
          'line-opacity': [
            'interpolate',
            ['linear'],
            ['zoom'],
            15,
            0,
            15.5,
            0.3,
          ],
          'line-translate': [
            'interpolate',
            ['linear'],
            ['zoom'],
            15,
            ['literal', [1.5, 1.5]],
            17,
            ['literal', [2.5, 2.5]],
            18,
            ['literal', [4, 4]],
            20,
            ['literal', [7, 7]],
          ],
          'line-translate-anchor': 'viewport',
          'line-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            15,
            3,
            17,
            10,
            18,
            22,
            20,
            88,
          ],
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'line',
      },
      {
        filter: [
          'all',
          ['any', ['has', 'is_bridge'], ['>', ['get', 'z_level'], 0]],
          ['==', ['get', 'kind_detail'], 'tertiary'],
          ['has', 'is_link'],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'bridge_tertiary-link-shadow',
        layout: {
          'line-join': 'round',
        },
        minzoom: 15,
        paint: {
          'line-blur': [
            'interpolate',
            ['linear'],
            ['zoom'],
            14,
            8,
            17,
            14,
            18,
            15,
            20,
            30,
          ],
          'line-color': 'hsl(228, 0%, 0%)',
          'line-opacity': [
            'interpolate',
            ['linear'],
            ['zoom'],
            15,
            0,
            15.5,
            0.3,
          ],
          'line-translate': [
            'interpolate',
            ['linear'],
            ['zoom'],
            14,
            ['literal', [1, 1]],
            17,
            ['literal', [2, 2]],
            18,
            ['literal', [2.5, 2.5]],
            20,
            ['literal', [5, 5]],
          ],
          'line-translate-anchor': 'viewport',
          'line-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            14,
            4,
            17,
            14,
            18,
            17,
            20,
            88,
          ],
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'line',
      },
      {
        filter: [
          'all',
          ['any', ['has', 'is_bridge'], ['>', ['get', 'z_level'], 0]],
          ['has', 'is_link'],
          [
            'match',
            ['get', 'kind_detail'],
            ['motorway', 'trunk', 'primary'],
            true,
            false,
          ],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'bridge_motorway-trunk-link-shadow',
        layout: {
          'line-join': 'round',
        },
        minzoom: 15,
        paint: {
          'line-blur': [
            'interpolate',
            ['linear'],
            ['zoom'],
            14,
            8,
            17,
            12,
            18,
            12,
            20,
            30,
          ],
          'line-color': 'hsl(228, 0%, 0%)',
          'line-opacity': [
            'interpolate',
            ['linear'],
            ['zoom'],
            15,
            0,
            15.5,
            0.3,
          ],
          'line-translate': [
            'interpolate',
            ['linear'],
            ['zoom'],
            14,
            ['literal', [1, 1]],
            17,
            ['literal', [3, 3]],
            18,
            ['literal', [4.5, 4.5]],
            20,
            ['literal', [9, 9]],
          ],
          'line-translate-anchor': 'viewport',
          'line-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            14,
            4,
            17,
            14,
            18,
            17,
            20,
            88,
          ],
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'line',
      },
      {
        filter: [
          'all',
          ['any', ['has', 'is_bridge'], ['>', ['get', 'z_level'], 0]],
          ['==', ['get', 'kind_detail'], 'tertiary'],
          ['!', ['has', 'is_link']],
          ['!', ['has', 'is_tunnel']],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'bridge_tertiary-shadow',
        layout: {
          'line-join': 'round',
        },
        minzoom: 12,
        paint: {
          'line-blur': [
            'interpolate',
            ['linear'],
            ['zoom'],
            14,
            5,
            17,
            15,
            18,
            25,
            20,
            45,
          ],
          'line-color': 'hsl(228, 0%, 0%)',
          'line-opacity': [
            'interpolate',
            ['linear'],
            ['zoom'],
            12,
            0,
            12.5,
            0.3,
          ],
          'line-translate': [
            'interpolate',
            ['linear'],
            ['zoom'],
            12,
            ['literal', [1, 1]],
            14,
            ['literal', [1.5, 1.5]],
            17,
            ['literal', [4, 4]],
            18,
            ['literal', [5, 5]],
            20,
            ['literal', [9, 9]],
          ],
          'line-translate-anchor': 'viewport',
          'line-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            12,
            0.5,
            14,
            4,
            14.5,
            8,
            17,
            14,
            18,
            26,
            20,
            100,
          ],
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'line',
      },
      {
        filter: [
          'all',
          ['any', ['has', 'is_bridge'], ['>', ['get', 'z_level'], 0]],
          [
            'match',
            ['get', 'kind_detail'],
            ['motorway', 'trunk', 'primary'],
            true,
            false,
          ],
          ['!', ['has', 'is_link']],
          ['!', ['has', 'is_tunnel']],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'bridge_motorway-trunk-shadow',
        layout: {
          'line-join': 'round',
        },
        minzoom: 13,
        paint: {
          'line-blur': [
            'interpolate',
            ['linear'],
            ['zoom'],
            14,
            8,
            17,
            15,
            18,
            15,
            20,
            30,
          ],
          'line-color': 'hsl(228, 0%, 0%)',
          'line-opacity': [
            'interpolate',
            ['linear'],
            ['zoom'],
            13,
            0,
            13.5,
            0.3,
          ],
          'line-translate': [
            'interpolate',
            ['linear'],
            ['zoom'],
            14,
            ['literal', [3, 3]],
            17,
            ['literal', [5, 5]],
            18,
            ['literal', [6, 6]],
            20,
            ['literal', [10, 10]],
          ],
          'line-translate-anchor': 'viewport',
          'line-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            14,
            5,
            17,
            25,
            18,
            54,
            20,
            210,
          ],
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'line',
      },
      {
        filter: [
          'all',
          ['any', ['has', 'is_bridge'], ['>', ['get', 'z_level'], 0]],
          [
            'any',
            ['==', ['get', 'kind_detail'], 'service'],
            [
              'all',
              ['==', ['get', 'kind_detail'], 'residential'],
              ['==', ['get', 'private'], true],
            ],
          ],
          ['==', ['get', 'kind'], 'minor_road'],
          ['!', ['has', 'is_tunnel']],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'bridge_service-casing',
        layout: {
          'line-join': 'round',
        },
        minzoom: 15,
        paint: {
          'line-color': 'hsl(228, 0%, 83%)',
          'line-gap-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            15,
            2,
            17,
            4,
            18,
            10,
            20,
            34,
          ],
          'line-opacity': ['interpolate', ['linear'], ['zoom'], 15, 0, 15.5, 1],
          'line-width': ['interpolate', ['linear'], ['zoom'], 15, 0.8, 18, 1.5],
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'line',
      },
      {
        filter: [
          'all',
          ['any', ['has', 'is_bridge'], ['>', ['get', 'z_level'], 0]],
          [
            'match',
            ['get', 'kind'],
            ['minor_road', 'unclassified', 'track'],
            true,
            false,
          ],
          ['!=', ['get', 'kind_detail'], 'service'],
          ['!=', ['get', 'private'], true],
          ['!', ['has', 'is_tunnel']],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'bridge_minor-casing',
        layout: {
          'line-join': 'round',
        },
        minzoom: 14.5,
        paint: {
          'line-color': 'hsl(228, 0%, 83%)',
          'line-gap-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            13.5,
            1,
            15,
            3,
            17,
            8,
            18,
            15,
            20,
            80,
          ],
          'line-opacity': ['interpolate', ['linear'], ['zoom'], 14.5, 0, 15, 1],
          'line-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            14.5,
            0.8,
            18,
            1.5,
          ],
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'line',
      },
      {
        filter: [
          'all',
          ['any', ['has', 'is_bridge'], ['>', ['get', 'z_level'], 0]],
          ['==', ['get', 'kind_detail'], 'tertiary'],
          ['has', 'is_link'],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'bridge_tertiary-link-casing',
        layout: {
          'line-join': 'round',
        },
        minzoom: 14.5,
        paint: {
          'line-color': 'hsl(228, 0%, 83%)',
          'line-gap-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            11,
            0.6,
            12,
            1,
            14,
            2,
            17,
            10,
            18,
            10,
            20,
            70,
          ],
          'line-opacity': ['interpolate', ['linear'], ['zoom'], 14.5, 0, 15, 1],
          'line-width': ['interpolate', ['linear'], ['zoom'], 15, 0.6, 17, 1.5],
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'line',
      },
      {
        filter: [
          'all',
          ['any', ['has', 'is_bridge'], ['>', ['get', 'z_level'], 0]],
          ['==', ['get', 'kind_detail'], 'secondary'],
          ['has', 'is_link'],
          ['!', ['has', 'is_tunnel']],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'bridge_primary-link-casing',
        layout: {
          'line-join': 'round',
        },
        minzoom: 12,
        paint: {
          'line-color': [
            'interpolate',
            ['linear'],
            ['zoom'],
            14.5,
            'hsl(228, 0%, 87%)',
            14.75,
            'hsl(228, 0%, 83%)',
          ],
          'line-gap-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            11,
            1,
            14,
            2.5,
            17,
            10,
            18,
            14,
            20,
            80,
          ],
          'line-opacity': ['interpolate', ['linear'], ['zoom'], 12, 0, 12.5, 1],
          'line-width': ['interpolate', ['linear'], ['zoom'], 15, 0.5, 17, 1.5],
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'line',
      },
      {
        filter: [
          'all',
          ['any', ['has', 'is_bridge'], ['>', ['get', 'z_level'], 0]],
          ['has', 'is_link'],
          [
            'match',
            ['get', 'kind_detail'],
            ['motorway', 'trunk', 'primary'],
            true,
            false,
          ],
          ['!', ['has', 'is_tunnel']],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'bridge_motorway-trunk-link-casing',
        layout: {
          'line-join': 'round',
        },
        minzoom: 13.5,
        paint: {
          'line-color': 'hsl(228, 0%, 80%)',
          'line-gap-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            8,
            0.7,
            10,
            1,
            11,
            1.25,
            13,
            2,
            14,
            2.5,
            17,
            12,
            18,
            14,
            20,
            70,
          ],
          'line-opacity': ['interpolate', ['linear'], ['zoom'], 13.5, 0, 14, 1],
          'line-width': ['interpolate', ['linear'], ['zoom'], 13, 0.4, 17, 1.5],
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'line',
      },
      {
        filter: [
          'all',
          ['any', ['has', 'is_bridge'], ['>', ['get', 'z_level'], 0]],
          ['==', ['get', 'kind_detail'], 'tertiary'],
          ['!', ['has', 'is_link']],
          ['!', ['has', 'is_tunnel']],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'bridge_tertiary-casing',
        layout: {
          'line-join': 'round',
        },
        minzoom: 14,
        paint: {
          'line-color': 'hsl(228, 0%, 83%)',
          'line-gap-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            10,
            0.6,
            12,
            1,
            14,
            3,
            17,
            12,
            18,
            22,
            20,
            100,
          ],
          'line-opacity': ['interpolate', ['linear'], ['zoom'], 14, 0, 14.5, 1],
          'line-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            14,
            1.125,
            15,
            1.5,
          ],
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'line',
      },
      {
        filter: [
          'all',
          ['any', ['has', 'is_bridge'], ['>', ['get', 'z_level'], 0]],
          ['==', ['get', 'kind_detail'], 'secondary'],
          ['!', ['has', 'is_link']],
          ['!', ['has', 'is_tunnel']],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'bridge_primary-casing',
        layout: {
          'line-join': 'round',
        },
        minzoom: 12,
        paint: {
          'line-color': [
            'interpolate',
            ['linear'],
            ['zoom'],
            14.5,
            'hsl(228, 0%, 87%)',
            14.75,
            'hsl(228, 0%, 83%)',
          ],
          'line-gap-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            9,
            0.8,
            11,
            1.25,
            12,
            2,
            14,
            4,
            17,
            16,
            18,
            30,
            20,
            100,
          ],
          'line-opacity': ['interpolate', ['linear'], ['zoom'], 12, 0, 12.5, 1],
          'line-width': ['interpolate', ['linear'], ['zoom'], 13, 1, 15, 1.5],
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'line',
      },
      {
        filter: [
          'all',
          ['any', ['has', 'is_bridge'], ['>', ['get', 'z_level'], 0]],
          [
            'match',
            ['get', 'kind_detail'],
            ['motorway', 'trunk', 'primary'],
            true,
            false,
          ],
          ['!', ['has', 'is_link']],
          ['!', ['has', 'is_tunnel']],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'bridge_motorway-trunk-casing',
        layout: {
          'line-join': 'round',
        },
        minzoom: 12,
        paint: {
          'line-color': 'hsl(228, 0%, 80%)',
          'line-gap-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            7,
            0.7,
            9,
            0.8,
            11,
            2,
            12,
            3,
            14,
            5,
            17,
            20,
            18,
            50,
            20,
            200,
          ],
          'line-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            8,
            0.5,
            13,
            0.6,
            15,
            1.5,
          ],
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'line',
      },
      {
        filter: [
          'all',
          ['any', ['has', 'is_bridge'], ['>', ['get', 'z_level'], 0]],
          [
            'any',
            ['==', ['get', 'kind_detail'], 'service'],
            [
              'all',
              ['==', ['get', 'kind_detail'], 'residential'],
              ['==', ['get', 'private'], true],
            ],
          ],
          ['==', ['get', 'kind'], 'minor_road'],
          ['!', ['has', 'is_tunnel']],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'bridge_service',
        layout: {
          'line-cap': 'round',
          'line-join': 'round',
        },
        minzoom: 15,
        paint: {
          'line-color': [
            'interpolate',
            ['linear'],
            ['zoom'],
            17,
            'hsl(228, 0%, 96%)',
            18,
            'hsl(228, 0%, 98%)',
          ],
          'line-opacity': ['interpolate', ['linear'], ['zoom'], 15, 0, 15.5, 1],
          'line-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            15,
            2,
            17,
            4,
            18,
            10,
            20,
            34,
          ],
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'line',
      },
      {
        filter: [
          'all',
          ['any', ['has', 'is_bridge'], ['>', ['get', 'z_level'], 0]],
          [
            'match',
            ['get', 'kind'],
            ['minor_road', 'unclassified', 'track'],
            true,
            false,
          ],
          ['!=', ['get', 'kind_detail'], 'service'],
          ['!=', ['get', 'private'], true],
          ['!', ['has', 'is_tunnel']],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'bridge_minor',
        layout: {
          'line-cap': 'round',
          'line-join': 'round',
        },
        minzoom: 12,
        paint: {
          'line-color': [
            'interpolate',
            ['linear'],
            ['zoom'],
            16,
            'hsl(228, 0%, 96%)',
            17,
            'hsl(228, 0%, 98%)',
          ],
          'line-opacity': ['interpolate', ['linear'], ['zoom'], 12.5, 0, 13, 1],
          'line-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            13.5,
            1,
            15,
            3,
            17,
            8,
            18,
            15,
            20,
            80,
          ],
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'line',
      },
      {
        filter: [
          'all',
          ['any', ['has', 'is_bridge'], ['>', ['get', 'z_level'], 0]],
          ['==', ['get', 'kind_detail'], 'tertiary'],
          ['has', 'is_link'],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'bridge_tertiary-link',
        layout: {
          'line-cap': 'round',
          'line-join': 'round',
        },
        minzoom: 11,
        paint: {
          'line-color': [
            'interpolate',
            ['linear'],
            ['zoom'],
            15,
            'hsl(228, 0%, 96%)',
            16,
            'hsl(228, 0%, 98%)',
          ],
          'line-opacity': ['interpolate', ['linear'], ['zoom'], 11.5, 0, 12, 1],
          'line-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            11,
            0.6,
            12,
            1,
            14,
            2,
            17,
            10,
            18,
            10,
            20,
            70,
          ],
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'line',
      },
      {
        filter: [
          'all',
          ['any', ['has', 'is_bridge'], ['>', ['get', 'z_level'], 0]],
          ['==', ['get', 'kind_detail'], 'secondary'],
          ['has', 'is_link'],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'bridge_primary-link',
        layout: {
          'line-cap': 'round',
          'line-join': 'round',
        },
        minzoom: 11,
        paint: {
          'line-color': [
            'interpolate',
            ['linear'],
            ['zoom'],
            12,
            'hsl(228, 0%, 96%)',
            14.5,
            'hsl(228, 0%, 97%)',
            15,
            'hsl(228, 0%, 98%)',
          ],
          'line-opacity': ['interpolate', ['linear'], ['zoom'], 11, 0, 11.5, 1],
          'line-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            11,
            1,
            14,
            2.5,
            17,
            10,
            18,
            14,
            20,
            80,
          ],
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'line',
      },
      {
        filter: [
          'all',
          ['any', ['has', 'is_bridge'], ['>', ['get', 'z_level'], 0]],
          ['has', 'is_link'],
          [
            'match',
            ['get', 'kind_detail'],
            ['motorway', 'trunk', 'primary'],
            true,
            false,
          ],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'bridge_motorway-trunk-link',
        layout: {
          'line-cap': 'round',
          'line-join': 'round',
        },
        minzoom: 8,
        paint: {
          'line-color': [
            'interpolate',
            ['linear'],
            ['zoom'],
            13.25,
            'hsl(228, 0%, 97%)',
            13.5,
            'hsl(228, 0%, 97%)',
            15,
            'hsl(228, 0%, 97%)',
            16,
            'hsl(228, 0%, 98%)',
          ],
          'line-opacity': ['interpolate', ['linear'], ['zoom'], 8, 0, 8.5, 1],
          'line-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            8,
            0.7,
            10,
            1,
            11,
            1.25,
            13,
            2,
            14,
            2.5,
            17,
            12,
            18,
            14,
            20,
            70,
          ],
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'line',
      },
      {
        filter: [
          'all',
          ['any', ['has', 'is_bridge'], ['>', ['get', 'z_level'], 0]],
          ['==', ['get', 'kind_detail'], 'tertiary'],
          ['!', ['has', 'is_link']],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'bridge_tertiary',
        layout: {
          'line-cap': 'round',
          'line-join': 'round',
        },
        minzoom: 10,
        paint: {
          'line-color': [
            'interpolate',
            ['linear'],
            ['zoom'],
            15,
            'hsl(228, 0%, 96%)',
            16,
            'hsl(228, 0%, 98%)',
          ],
          'line-opacity': ['interpolate', ['linear'], ['zoom'], 10, 0, 10.5, 1],
          'line-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            10,
            0.6,
            12,
            1,
            14,
            3,
            17,
            12,
            18,
            22,
            20,
            100,
          ],
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'line',
      },
      {
        filter: [
          'all',
          ['any', ['has', 'is_bridge'], ['>', ['get', 'z_level'], 0]],
          ['==', ['get', 'kind_detail'], 'secondary'],
          ['!', ['has', 'is_link']],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'bridge_primary',
        layout: {
          'line-cap': 'round',
          'line-join': 'round',
        },
        minzoom: 8,
        paint: {
          'line-color': [
            'interpolate',
            ['linear'],
            ['zoom'],
            12,
            'hsl(228, 0%, 96%)',
            14.5,
            'hsl(228, 0%, 97%)',
            15,
            'hsl(228, 0%, 98%)',
          ],
          'line-opacity': ['interpolate', ['linear'], ['zoom'], 8.5, 0, 9, 1],
          'line-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            9,
            0.8,
            11,
            1.25,
            12,
            2,
            14,
            4,
            17,
            16,
            18,
            30,
            20,
            100,
          ],
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'line',
      },
      {
        filter: [
          'all',
          ['any', ['has', 'is_bridge'], ['>', ['get', 'z_level'], 0]],
          [
            'match',
            ['get', 'kind_detail'],
            ['motorway', 'trunk', 'primary'],
            true,
            false,
          ],
          ['!', ['has', 'is_link']],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'bridge_motorway-trunk',
        layout: {
          'line-cap': 'round',
          'line-join': 'round',
        },
        minzoom: 11,
        paint: {
          'line-color': [
            'interpolate',
            ['linear'],
            ['zoom'],
            15,
            'hsl(228, 0%, 97%)',
            16,
            'hsl(228, 0%, 98%)',
          ],
          'line-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            7,
            0.7,
            9,
            0.8,
            11,
            2,
            12,
            3,
            14,
            5,
            17,
            20,
            18,
            50,
            20,
            200,
          ],
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'line',
      },
      {
        filter: [
          'all',
          ['match', ['get', 'kind'], ['transit', 'rail'], true, false],
          ['has', 'is_bridge'],
          ['!', ['has', 'service']],
          [
            'case',
            [
              'all',
              ['has', 'kind_detail'],
              ['==', ['get', 'kind_detail'], 'disused'],
            ],
            false,
            true,
          ],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'rail_bridge',
        layout: {
          'line-join': 'round',
        },
        minzoom: 11,
        paint: {
          'line-color': [
            'interpolate',
            ['linear'],
            ['zoom'],
            16,
            'hsl(228, 0%, 74%)',
            17,
            'hsl(228, 0%, 70%)',
          ],
          'line-opacity': ['interpolate', ['linear'], ['zoom'], 11.5, 0, 12, 1],
          'line-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            15,
            1,
            17,
            1.5,
            20,
            2,
          ],
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'line',
      },
      {
        filter: [
          'all',
          ['match', ['get', 'kind'], ['transit', 'rail'], true, false],
          ['has', 'is_bridge'],
          ['!', ['has', 'service']],
          [
            'case',
            [
              'all',
              ['has', 'kind_detail'],
              ['==', ['get', 'kind_detail'], 'disused'],
            ],
            false,
            true,
          ],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'rail_tie_bridge',
        minzoom: 14,
        paint: {
          'line-color': [
            'interpolate',
            ['linear'],
            ['zoom'],
            16,
            'hsl(228, 0%, 74%)',
            17,
            'hsl(228, 0%, 70%)',
          ],
          'line-dasharray': [0.2, 2],
          'line-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            14,
            4,
            15,
            5,
            16,
            5,
            17,
            6,
            18,
            7,
            19,
            8,
            20,
            9,
          ],
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'line',
      },
      {
        filter: [
          'all',
          [
            'step',
            ['zoom'],
            ['<', ['to-number', ['get', 'display_class']], 5],
            9,
            ['<', ['to-number', ['get', 'display_class']], 7],
            10,
            ['<', ['to-number', ['get', 'display_class']], 8],
            13,
            true,
          ],
          [
            'match',
            ['get', 'kind'],
            ['reef', 'riverbank', 'fountain', 'playa', 'river'],
            false,
            true,
          ],
          ['!=', ['get', 'name'], 'Pool'],
          ['==', ['geometry-type'], 'Point'],
        ],
        id: 'water_label-point',
        layout: {
          'symbol-sort-key': ['to-number', ['get', 'display_class']],
          'text-field': ['coalesce', ['get', 'name:en'], ['get', 'name']],
          'text-font': ['Amazon Ember Regular,Noto Sans Regular'],
          'text-letter-spacing': 0.1,
          'text-line-height': 1,
          'text-max-width': 5,
          'text-padding': 40,
          'text-size': ['interpolate', ['linear'], ['zoom'], 12, 10, 16, 12],
        },
        minzoom: 0,
        paint: {
          'text-color': 'hsl(240, 2%, 50%)',
          'text-halo-blur': 0.8,
          'text-halo-color': 'hsla(228, 9%, 89%, 0.3)',
          'text-halo-width': 1.2,
        },
        source: 'aws',
        'source-layer': 'water',
        type: 'symbol',
      },
      {
        filter: [
          'all',
          ['!', ['has', 'is_tunnel']],
          ['!', ['has', 'intermittent']],
          [
            'match',
            ['get', 'kind'],
            ['reef', 'riverbank', 'fountain', 'playa'],
            false,
            true,
          ],
          ['case', ['has', 'name:en'], true, ['has', 'name'], true, false],
          [
            'case',
            [
              '<=',
              ['length', ['coalesce', ['get', 'name:en'], ['get', 'name']]],
              20,
            ],
            true,
            false,
          ],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'water_label-line',
        layout: {
          'symbol-placement': 'line',
          'symbol-spacing': 500,
          'text-field': ['coalesce', ['get', 'name:en'], ['get', 'name']],
          'text-font': ['Amazon Ember Regular,Noto Sans Regular'],
          'text-letter-spacing': 0.3,
          'text-size': ['interpolate', ['linear'], ['zoom'], 12, 10, 16, 12],
        },
        minzoom: 12,
        paint: {
          'text-color': 'hsl(240, 2%, 50%)',
          'text-halo-blur': 0.8,
          'text-halo-color': 'hsla(228, 9%, 89%, 0.3)',
          'text-halo-width': 1.5,
        },
        source: 'aws',
        'source-layer': 'water',
        type: 'symbol',
      },
      {
        filter: [
          'all',
          ['==', ['get', 'kind'], 'minor_road'],
          ['!=', ['get', 'kind_detail'], 'service'],
          ['!=', ['get', 'private'], true],
          ['!', ['has', 'is_link']],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'road_label_small',
        layout: {
          'symbol-placement': 'line',
          'symbol-spacing': 300,
          'text-field': ['coalesce', ['get', 'name:en'], ['get', 'name']],
          'text-font': ['Amazon Ember Condensed RC Regular,Noto Sans Regular'],
          'text-max-angle': 40,
          'text-offset': [
            'interpolate',
            ['linear'],
            ['zoom'],
            13,
            ['literal', [0, -0.3]],
            14,
            ['literal', [0, 0.02]],
          ],
          'text-padding': 1,
          'text-pitch-alignment': 'viewport',
          'text-size': [
            'interpolate',
            ['linear'],
            ['zoom'],
            13,
            8,
            18,
            16,
            22,
            24,
          ],
          'text-transform': 'uppercase',
        },
        minzoom: 13,
        paint: {
          'text-color': 'hsl(228, 0%, 50%)',
          'text-halo-blur': 0.75,
          'text-halo-color': 'hsl(228, 0%, 92%)',
          'text-halo-width': 2,
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'symbol',
      },
      {
        filter: [
          'all',
          [
            'step',
            ['zoom'],
            [
              'match',
              ['get', 'kind_detail'],
              ['primary', 'secondary'],
              true,
              false,
            ],
            10.25,
            [
              'match',
              ['get', 'kind_detail'],
              ['primary', 'secondary', 'tertiary'],
              true,
              false,
            ],
          ],
          ['!', ['has', 'is_link']],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'road_label_medium',
        layout: {
          'symbol-placement': 'line',
          'symbol-spacing': 300,
          'text-field': ['coalesce', ['get', 'name:en'], ['get', 'name']],
          'text-font': ['Amazon Ember Condensed RC Regular,Noto Sans Regular'],
          'text-max-angle': 40,
          'text-offset': [0, 0.05],
          'text-padding': 1,
          'text-pitch-alignment': 'viewport',
          'text-size': [
            'interpolate',
            ['linear'],
            ['zoom'],
            12,
            9,
            18,
            17,
            22,
            25,
          ],
          'text-transform': 'uppercase',
        },
        minzoom: 9,
        paint: {
          'text-color': 'hsl(228, 0%, 50%)',
          'text-halo-blur': 0.75,
          'text-halo-color': 'hsl(228, 0%, 92%)',
          'text-halo-width': 1,
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'symbol',
      },
      {
        filter: [
          'all',
          ['match', ['get', 'kind_detail'], ['motorway', 'trunk'], true, false],
          ['!', ['has', 'is_link']],
          ['==', ['geometry-type'], 'LineString'],
        ],
        id: 'road_label_large',
        layout: {
          'symbol-placement': 'line',
          'symbol-spacing': 300,
          'text-field': ['coalesce', ['get', 'name:en'], ['get', 'name']],
          'text-font': ['Amazon Ember Condensed RC Bold,Noto Sans Bold'],
          'text-max-angle': 40,
          'text-offset': [0, 0.05],
          'text-padding': 1,
          'text-pitch-alignment': 'viewport',
          'text-size': [
            'interpolate',
            ['linear'],
            ['zoom'],
            12,
            10,
            18,
            18,
            22,
            26,
          ],
          'text-transform': 'uppercase',
        },
        minzoom: 8,
        paint: {
          'text-color': 'hsl(228, 0%, 45%)',
          'text-halo-blur': 0.75,
          'text-halo-color': [
            'match',
            ['get', 'kind_detail'],
            ['motorway', 'trunk'],
            'hsl(228, 0%, 93%)',
            'hsl(228, 0%, 92%)',
          ],
          'text-halo-width': 1.25,
        },
        source: 'aws',
        'source-layer': 'roads',
        type: 'symbol',
      },
      {
        filter: [
          'all',
          [
            'match',
            ['get', 'kind'],
            ['park', 'cemetery', 'garden', 'zoo', 'golf_course'],
            true,
            false,
          ],
          ['>=', ['zoom'], ['to-number', ['get', 'min_zoom']]],
          ['==', ['geometry-type'], 'Point'],
        ],
        id: 'poi_landuse_park_lowzoom',
        layout: {
          'text-field': ['coalesce', ['get', 'name:en'], ['get', 'name']],
          'text-font': ['Amazon Ember Condensed RC Bold,Noto Sans Bold'],
          'text-line-height': 1,
          'text-max-width': 4,
          'text-padding': 40,
          'text-size': ['interpolate', ['linear'], ['zoom'], 14, 10, 16, 11],
        },
        maxzoom: 16,
        minzoom: 14,
        paint: {
          'text-color': [
            'case',
            [
              'match',
              ['get', 'kind'],
              ['sports_centre', 'cemetery'],
              true,
              false,
            ],
            'hsl(228, 0%, 50%)',
            'hsl(228, 0%, 50%)',
          ],
          'text-halo-blur': 0.5,
          'text-halo-color': 'hsl(228, 0%, 97%)',
          'text-halo-width': 1.25,
        },
        source: 'aws',
        'source-layer': 'landuse',
        type: 'symbol',
      },
      {
        filter: [
          'all',
          [
            'match',
            ['get', 'kind'],
            ['park', 'cemetery', 'garden', 'zoo', 'golf_course'],
            true,
            false,
          ],
          ['>=', ['zoom'], ['to-number', ['get', 'min_zoom']]],
          ['==', ['geometry-type'], 'Point'],
        ],
        id: 'poi_landuse_park',
        layout: {
          'icon-image': [
            'case',
            ['==', ['get', 'kind'], 'cemetery'],
            'cemetery',
            'park',
          ],
          'text-anchor': 'top',
          'text-field': ['coalesce', ['get', 'name:en'], ['get', 'name']],
          'text-font': ['Amazon Ember Condensed RC Bold,Noto Sans Bold'],
          'text-line-height': 1,
          'text-offset': [0, 1.5],
          'text-size': ['interpolate', ['linear'], ['zoom'], 14, 10, 16, 11],
        },
        minzoom: 16,
        paint: {
          'text-color': [
            'case',
            ['==', ['get', 'kind'], 'cemetery'],
            'hsl(228, 0%, 50%)',
            'hsl(228, 0%, 50%)',
          ],
          'text-halo-blur': 0.5,
          'text-halo-color': 'hsl(228, 0%, 97%)',
          'text-halo-width': 1.25,
        },
        source: 'aws',
        'source-layer': 'landuse',
        type: 'symbol',
      },
      {
        filter: [
          'all',
          [
            'match',
            ['get', 'kind'],
            [
              'hospital',
              'university',
              'commercial',
              'industrial',
              'harbour',
              'military',
            ],
            true,
            false,
          ],
          ['==', ['geometry-type'], 'Point'],
        ],
        id: 'poi_landuse_public_complex',
        layout: {
          'icon-image': [
            'match',
            ['get', 'kind'],
            'hospital',
            'hospital',
            'commercial',
            'shopping',
            'university',
            'education',
            'harbour',
            'harbour',
            'marker',
          ],
          'text-anchor': 'top',
          'text-field': ['coalesce', ['get', 'name:en'], ['get', 'name']],
          'text-font': ['Amazon Ember Condensed RC Bold,Noto Sans Bold'],
          'text-line-height': 1,
          'text-offset': [0, 1.5],
          'text-size': ['interpolate', ['linear'], ['zoom'], 14, 10, 16, 11],
        },
        minzoom: 14,
        paint: {
          'text-color': [
            'match',
            ['get', 'kind'],
            'hospital',
            'hsl(228, 0%, 50%)',
            'university',
            'hsl(228, 0%, 50%)',
            'hsl(228, 0%, 50%)',
          ],
          'text-halo-blur': 0.5,
          'text-halo-color': 'hsl(228, 0%, 97%)',
          'text-halo-width': 1.25,
        },
        source: 'aws',
        'source-layer': 'landuse',
        type: 'symbol',
      },
      {
        filter: [
          'all',
          [
            'all',
            ['!=', ['get', 'kind'], 'unrecognized_region'],
            ['==', ['get', 'kind'], 'region'],
          ],
          ['==', ['geometry-type'], 'Point'],
        ],
        id: 'admin_label_region',
        layout: {
          'icon-allow-overlap': true,
          'icon-ignore-placement': true,
          'text-field': [
            'step',
            ['zoom'],
            ['get', 'name:short'],
            4,
            ['coalesce', ['get', 'name:en'], ['get', 'name']],
          ],
          'text-font': ['Amazon Ember Condensed RC Bold,Noto Sans Bold'],
          'text-letter-spacing': [
            'interpolate',
            ['linear'],
            ['zoom'],
            3.75,
            0.25,
            6.5,
            0.3,
          ],
          'text-line-height': 1,
          'text-max-width': 8,
          'text-size': [
            'interpolate',
            ['linear'],
            ['zoom'],
            4,
            11,
            6,
            14,
            8,
            18,
          ],
          'text-transform': 'uppercase',
        },
        maxzoom: 8,
        minzoom: 3.75,
        paint: {
          'text-color': 'hsl(228, 0%, 60%)',
          'text-halo-color': 'hsl(228, 0%, 91%)',
          'text-halo-width': ['interpolate', ['linear'], ['zoom'], 3, 1, 6, 2],
        },
        source: 'aws',
        'source-layer': 'places',
        type: 'symbol',
      },
      {
        filter: [
          'all',
          [
            'step',
            ['zoom'],
            [
              'match',
              ['get', 'kind_detail'],
              ['city', 'locality', 'town', 'village', 'hamlet', 'borough'],
              true,
              false,
            ],
            12.5,
            [
              'match',
              ['get', 'kind'],
              ['neighbourhood', 'borough', 'macrohood'],
              true,
              false,
            ],
          ],
          [
            'all',
            [
              'match',
              ['get', 'kind'],
              ['unrecognized_locality', 'unrecognized_borough'],
              false,
              true,
            ],
            [
              'match',
              ['get', 'kind'],
              ['neighbourhood', 'borough', 'macrohood'],
              true,
              false,
            ],
          ],
          ['!', ['has', 'population']],
          ['==', ['geometry-type'], 'Point'],
        ],
        id: 'place_label_locality_settlement_small',
        layout: {
          'symbol-sort-key': ['get', 'min_zoom'],
          'text-field': ['coalesce', ['get', 'name:en'], ['get', 'name']],
          'text-font': ['Amazon Ember Condensed RC Bold,Noto Sans Bold'],
          'text-line-height': 1,
          'text-max-width': 8,
          'text-padding': 100,
          'text-size': ['interpolate', ['linear'], ['zoom'], 12, 11, 15, 15],
          'text-transform': 'uppercase',
        },
        maxzoom: 16,
        minzoom: 12,
        paint: {
          'text-color': 'hsl(228, 0%, 60%)',
          'text-halo-blur': 0.75,
          'text-halo-color': 'hsl(228, 0%, 97%)',
          'text-halo-width': 1.25,
        },
        source: 'aws',
        'source-layer': 'places',
        type: 'symbol',
      },
      {
        filter: [
          'all',
          ['==', ['get', 'kind'], 'airport'],
          ['has', 'name:short'],
          [
            'step',
            ['zoom'],
            [
              'case',
              ['==', ['get', 'kind_detail'], 'international'],
              true,
              ['==', ['get', 'kind_detail'], 'regional'],
              true,
              ['has', 'has_national_importance'],
              true,
              false,
            ],
            12,
            true,
          ],
          ['!', ['in', 'Terminal', ['get', 'name']]],
          ['==', ['geometry-type'], 'Point'],
        ],
        id: 'airport_label',
        layout: {
          'icon-anchor': 'top',
          'icon-image': 'airport',
          'icon-rotation-alignment': 'viewport',
          'symbol-sort-key': [
            'case',
            ['has', 'kind_detail'],
            0,
            ['has', 'has_national_importance'],
            0,
            1,
          ],
          'text-anchor': 'bottom',
          'text-field': [
            'step',
            ['zoom'],
            ['get', 'name:short'],
            13,
            [
              'concat',
              ['coalesce', ['get', 'name:en'], ['get', 'name']],
              ' (',
              ['get', 'name:short'],
              ')',
            ],
          ],
          'text-font': ['Amazon Ember Condensed RC Bold,Noto Sans Bold'],
          'text-line-height': 1,
          'text-max-width': 4,
          'text-offset': [
            'interpolate',
            ['linear'],
            ['zoom'],
            12,
            ['literal', [0, -0.2]],
            13,
            ['literal', [0, -0.4]],
          ],
          'text-size': [
            'interpolate',
            ['linear'],
            ['zoom'],
            10,
            12,
            14,
            12,
            16,
            16,
          ],
        },
        minzoom: 10,
        paint: {
          'text-color': 'hsl(228, 0%, 60%)',
          'text-halo-blur': 0.8,
          'text-halo-color': 'hsl(228, 0%, 98%)',
          'text-halo-width': 1,
        },
        source: 'aws',
        'source-layer': 'pois',
        type: 'symbol',
      },
      {
        filter: [
          'all',
          [
            'match',
            ['get', 'kind_detail'],
            ['city', 'locality', 'town', 'village', 'hamlet'],
            true,
            false,
          ],
          [
            'all',
            ['!=', ['get', 'kind'], 'unrecognized_locality'],
            ['==', ['get', 'kind'], 'locality'],
          ],
          ['<', ['get', 'population'], 1000000],
          [
            'step',
            ['zoom'],
            ['>=', ['get', 'population'], 500],
            8,
            ['>=', ['get', 'population'], 350],
            10,
            ['>=', ['get', 'population'], 1000],
            11,
            ['>=', ['get', 'population'], 500],
            12,
            ['>=', ['get', 'population'], 1000],
          ],
          ['==', ['geometry-type'], 'Point'],
        ],
        id: 'place_label_locality_settlement',
        layout: {
          'icon-anchor': [
            'case',
            ['>=', ['get', 'population'], 1200000],
            'top',
            'center',
          ],
          'icon-image': [
            'step',
            ['zoom'],
            ['case', ['has', 'country_capital'], 'citydot-open', 'citydot'],
            8,
            [
              'case',
              [
                'all',
                ['has', 'country_capital'],
                ['>', ['get', 'population'], 100000],
              ],
              'citydot-open',
              [
                'all',
                ['has', 'country_capital'],
                ['==', ['get', 'population'], 100000],
              ],
              'citydot-open_lowrank',
              ['>', ['get', 'population'], 100000],
              'citydot',
              'citydot_lowrank',
            ],
          ],
          'symbol-sort-key': ['*', -1, ['get', 'population']],
          'text-field': ['coalesce', ['get', 'name:en'], ['get', 'name']],
          'text-font': ['Amazon Ember Regular,Noto Sans Regular'],
          'text-justify': 'auto',
          'text-line-height': 1,
          'text-padding': 8,
          'text-radial-offset': 0.1,
          'text-size': [
            'interpolate',
            ['linear'],
            ['zoom'],
            9,
            11,
            10,
            ['case', ['>=', ['get', 'population'], 200], 13, 11],
            11,
            [
              'case',
              ['>=', ['get', 'population'], 200],
              14,
              ['>=', ['get', 'population'], 100],
              13,
              ['>=', ['get', 'population'], 50],
              12,
              11,
            ],
            14,
            ['case', ['>=', ['get', 'population'], 200], 15, 13],
          ],
          'text-variable-anchor': [
            'step',
            ['zoom'],
            [
              'literal',
              [
                'bottom',
                'bottom-right',
                'bottom-left',
                'top-left',
                'top-right',
              ],
            ],
            9,
            ['literal', ['center']],
          ],
        },
        maxzoom: 16,
        minzoom: 7,
        paint: {
          'icon-opacity': [
            'interpolate',
            ['linear'],
            ['zoom'],
            3,
            1,
            8.5,
            1,
            9,
            0,
          ],
          'text-color': [
            'interpolate',
            ['linear'],
            ['zoom'],
            9,
            'hsl(228, 0%, 42%)',
            10,
            'hsl(228, 0%, 42%)',
            11,
            [
              'case',
              ['>=', ['get', 'population'], 20000],
              'hsl(228, 0%, 39%)',
              'hsl(228, 0%, 42%)',
            ],
            12,
            [
              'case',
              ['>=', ['get', 'population'], 10000],
              'hsl(228, 0%, 39%)',
              'hsl(228, 0%, 42%)',
            ],
            13,
            'hsl(228, 0%, 39%)',
          ],
          'text-halo-blur': 0.25,
          'text-halo-color': 'hsl(228, 0%, 97%)',
          'text-halo-width': [
            'case',
            ['>=', ['get', 'population'], 10000],
            1.25,
            1,
          ],
        },
        source: 'aws',
        'source-layer': 'places',
        type: 'symbol',
      },
      {
        filter: [
          'all',
          [
            'all',
            ['!=', ['get', 'kind'], 'unrecognized_locality'],
            ['==', ['get', 'kind'], 'locality'],
          ],
          [
            'step',
            ['zoom'],
            ['>=', ['get', 'population'], 1200000],
            4,
            ['>=', ['get', 'population'], 400000],
            6,
            ['>=', ['get', 'population'], 200000],
            7,
            ['>=', ['get', 'population'], 100000],
          ],
          ['==', ['geometry-type'], 'Point'],
        ],
        id: 'place_label_locality_city',
        layout: {
          'icon-anchor': [
            'case',
            ['>=', ['get', 'population'], 1200000],
            'top',
            'center',
          ],
          'icon-image': [
            'step',
            ['zoom'],
            ['case', ['has', 'country_capital'], 'citydot-open', 'citydot'],
            8,
            [
              'case',
              [
                'all',
                ['has', 'country_capital'],
                ['>', ['get', 'population'], 100000],
              ],
              'citydot-open',
              [
                'all',
                ['has', 'country_capital'],
                ['==', ['get', 'population'], 100000],
              ],
              'citydot-open_lowrank',
              ['>', ['get', 'population'], 100000],
              'citydot',
              'citydot_lowrank',
            ],
          ],
          'symbol-sort-key': ['*', -1, ['get', 'population']],
          'text-field': ['coalesce', ['get', 'name:en'], ['get', 'name']],
          'text-font': [
            'step',
            ['zoom'],
            ['literal', ['Amazon Ember Bold,Noto Sans Bold']],
            4,
            [
              'case',
              ['>=', ['get', 'population'], 1200000],
              ['literal', ['Amazon Ember Bold,Noto Sans Bold']],
              ['literal', ['Amazon Ember Medium,Noto Sans Medium']],
            ],
            6,
            [
              'case',
              ['>=', ['get', 'population'], 400000],
              ['literal', ['Amazon Ember Bold,Noto Sans Bold']],
              ['literal', ['Amazon Ember Medium,Noto Sans Medium']],
            ],
            8,
            [
              'case',
              ['>=', ['get', 'population'], 400000],
              ['literal', ['Amazon Ember Bold,Noto Sans Bold']],
              ['>=', ['get', 'population'], 200000],
              ['literal', ['Amazon Ember Medium,Noto Sans Medium']],
              ['literal', ['Amazon Ember Regular,Noto Sans Regular']],
            ],
            9,
            [
              'case',
              ['>=', ['get', 'population'], 400000],
              ['literal', ['Amazon Ember Bold,Noto Sans Bold']],
              ['literal', ['Amazon Ember Medium,Noto Sans Medium']],
            ],
          ],
          'text-justify': 'auto',
          'text-line-height': 1,
          'text-radial-offset': [
            'case',
            ['>=', ['get', 'population'], 1200000],
            0.4,
            0.6,
          ],
          'text-size': [
            'interpolate',
            ['linear'],
            ['zoom'],
            4,
            ['case', ['>=', ['get', 'population'], 5000000], 11, 10],
            6,
            [
              'case',
              ['>=', ['get', 'population'], 5000000],
              15,
              ['>=', ['get', 'population'], 1000000],
              13,
              10,
            ],
            8,
            [
              'case',
              ['>=', ['get', 'population'], 5000000],
              17,
              ['>=', ['get', 'population'], 1000000],
              15,
              ['>=', ['get', 'population'], 200000],
              13,
              11,
            ],
            10,
            [
              'case',
              ['>=', ['get', 'population'], 5000000],
              21,
              ['>=', ['get', 'population'], 1000000],
              19,
              ['>=', ['get', 'population'], 200000],
              17,
              12,
            ],
            13,
            [
              'case',
              ['>=', ['get', 'population'], 5000000],
              23,
              ['>=', ['get', 'population'], 1000000],
              21,
              ['>=', ['get', 'population'], 200000],
              19,
              14,
            ],
          ],
          'text-variable-anchor': [
            'step',
            ['zoom'],
            [
              'literal',
              [
                'bottom',
                'bottom-right',
                'bottom-left',
                'top-left',
                'top-right',
              ],
            ],
            9,
            ['literal', ['center']],
          ],
        },
        maxzoom: 14,
        minzoom: 3,
        paint: {
          'icon-opacity': [
            'interpolate',
            ['linear'],
            ['zoom'],
            3,
            0.5,
            8,
            0.5,
            8.5,
            0,
          ],
          'text-color': [
            'interpolate',
            ['linear'],
            ['zoom'],
            6,
            'hsl(228, 0%, 39%)',
            8,
            [
              'case',
              ['>', ['get', 'population'], 100000],
              'hsl(228, 0%, 39%)',
              'hsl(228, 0%, 45%)',
            ],
            9,
            [
              'case',
              ['>', ['get', 'population'], 100000],
              'hsl(228, 0%, 39%)',
              'hsl(228, 0%, 45%)',
            ],
            12.49,
            'hsl(228, 0%, 39%)',
            12.5,
            'hsl(228, 0%, 45%)',
          ],
          'text-halo-blur': [
            'interpolate',
            ['linear'],
            ['zoom'],
            6,
            0.5,
            8,
            ['case', ['>=', ['get', 'population'], 1200000], 2, 0.5],
          ],
          'text-halo-color': 'hsl(228, 0%, 97%)',
          'text-halo-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            6,
            0.8,
            8,
            [
              'case',
              ['>=', ['coalesce', ['get', 'population'], 0], 1200000],
              2,
              1.25,
            ],
          ],
        },
        source: 'aws',
        'source-layer': 'places',
        type: 'symbol',
      },
      {
        filter: [
          'all',
          [
            'all',
            ['!=', ['get', 'kind'], 'unrecognized_country'],
            ['==', ['get', 'kind'], 'country'],
          ],
          [
            'step',
            ['zoom'],
            ['<=', ['get', 'min_zoom'], 1],
            2,
            ['<=', ['get', 'min_zoom'], 3],
            3,
            ['!', ['in', ['get', 'iso_code'], ['literal', ['MB', 'UN']]]],
            7,
            true,
          ],
          ['==', ['geometry-type'], 'Point'],
        ],
        id: 'admin_label_country',
        layout: {
          'symbol-sort-key': ['-', 20, ['get', 'population_rank']],
          'text-field': ['coalesce', ['get', 'name:en'], ['get', 'name']],
          'text-font': ['Amazon Ember Condensed RC Bold,Noto Sans Bold'],
          'text-letter-spacing': 0.2,
          'text-line-height': 1,
          'text-max-width': 8,
          'text-padding': 3,
          'text-size': [
            'interpolate',
            ['linear'],
            ['zoom'],
            1,
            7,
            2,
            8.5,
            4,
            11,
            5,
            12,
            6,
            15,
          ],
          'text-transform': 'uppercase',
        },
        maxzoom: 8,
        minzoom: 1,
        paint: {
          'text-color': 'hsl(228, 0%, 55%)',
          'text-halo-blur': 1,
          'text-halo-color': 'hsla(0, 0%, 94%, 0.75)',
          'text-halo-width': ['interpolate', ['linear'], ['zoom'], 1, 1, 4, 2],
        },
        source: 'aws',
        'source-layer': 'places',
        type: 'symbol',
      },
      {
        filter: [
          'all',
          ['==', ['get', 'kind'], 'continent'],
          ['==', ['geometry-type'], 'Point'],
        ],
        id: 'admin_label_continent',
        layout: {
          'text-field': ['coalesce', ['get', 'name:en'], ['get', 'name']],
          'text-font': ['Amazon Ember Condensed RC Regular,Noto Sans Regular'],
          'text-letter-spacing': 0.2,
          'text-line-height': 1,
          'text-padding': 3,
          'text-size': 14,
          'text-transform': 'uppercase',
        },
        maxzoom: 2,
        minzoom: 0,
        paint: {
          'text-color': 'hsl(228, 0%, 55%)',
          'text-halo-blur': 1,
          'text-halo-color': 'hsla(0, 0%, 94%, 0.75)',
          'text-halo-width': ['interpolate', ['linear'], ['zoom'], 1, 1, 4, 2],
        },
        source: 'aws',
        'source-layer': 'earth',
        type: 'symbol',
      },
    ],
    created: '0001-01-01T00:00:00Z',
    modified: '0001-01-01T00:00:00Z',
    id: 'monochrome-global-light-default-3.0.0',
  };
};
